import store from "@/controller/baseController";
import Enums from "@/enums/enums";
import peakUtility from "@/function/peakUtility";
import importHelper from "@/helper/importTemplateHelper";
import paymentHelper from "@/helper/paymentHelper.js";
import { GetTransactionName } from "@/helper/shareHelper";
import transactionItemHelper, { DisablePartialQuotationItem } from "@/helper/transactionItemHelper";
import {
  GetCreateReferenceDepositSummaryDefualt,
  default as transactionHelper,
} from "@/helper/transactionItemHelper.js";
import userHelper from "@/helper/userHelper";
import i18n from "@/locales/i18n";
import dayjs from "dayjs";
import { ExtractBankDetailsFromRemark, SuggestContactByRemark } from "../helper/reconciledHelper";

function GetContactDefaultForCreateTransaction() {
  return {
    id: 0,
    contactFullName: "",
    contactCode: "",
    contactTaxId: "",
    contactBranchCode: "",
    address: "",
    contactType: Enums.MerchantType.None,
    incomeDueDateTypeId: 0,
    incomeDueDateDay: 0,
    outflowDueDateTypeId: 0,
    outflowDueDateDay: 0,
    merchantType: Enums.MerchantType.None,
    disabled: false,
    hidden: false,
    validateError: false,
  };
}
function GetModelQuotation(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Quotation",
    transactionType: Enums.TransactionType.Quotation,
    financeType: Enums.FinanceType.InFlow,
    transactionItemType: Enums.TransactionItemType.Inventory,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Valid_Until",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    isValidateCreditLimit: true,
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.Quotation, Enums.FinanceType.InFlow)
  );
  return model;
}
function SetEasyEditModel(transaction, transactionDetail) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.transactionType = transactionDetail.transactionType;
  transaction.financeType = transactionDetail.financeType;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceType = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.isHumanChange = true;

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        Enums.ExpenseType.None
      );
      transactionItem.id = transactionDetailItem.id;
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  if (transactionDetail.referenceDepositSummary && transaction.referenceDepositSummary) {
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal =
      transactionDetail.referenceDepositSummary.fromCurrencyDepositPreVatTotal;
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal =
      transactionDetail.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal;
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal =
      transactionDetail.referenceDepositSummary.fromCurrencyDepositVatTotal;
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal =
      transactionDetail.referenceDepositSummary.fromCurrencyDepositZeroVatTotal;
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal =
      transactionDetail.referenceDepositSummary.toCurrencyDepositPreVatTotal;
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal =
      transactionDetail.referenceDepositSummary.toCurrencyDepositVatExemptedTotal;
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal =
      transactionDetail.referenceDepositSummary.toCurrencyDepositVatTotal;
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal =
      transactionDetail.referenceDepositSummary.toCurrencyDepositZeroVatTotal;
  }
  transaction.referenceDepositList = [];
  if (transactionDetail.referenceDepositList && transactionDetail.referenceDepositList.length > 0) {
    for (const referenceDeposit of transactionDetail.referenceDepositList) {
      transaction.referenceDepositList.push({
        fromCurrencyNetTotal: referenceDeposit.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceDeposit.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceDeposit.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceDeposit.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceDeposit.fromCurrencyVatExemptedTotal,
        toCurrencyNetTotal: referenceDeposit.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceDeposit.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceDeposit.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceDeposit.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceDeposit.toCurrencyVatExemptedTotal,
      });
    }
  }
}

function SetEditQuotationModel(transaction, transactionDetail, allocationList) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.contact.disabled = GetDisableContactByReference(transactionDetail);
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.userId = transactionDetail.userId;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        Enums.ExpenseType.None,
        transaction.transactionItemType
      );
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}
function SetCopyPurchaseRequisitionModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyQuotationModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.isValidateError = false;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyQuotationToPurchaseOrderModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.number;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = false;

  let allocationTransacionRawList = transactionHelper.SetAllocationTransactionByFinanceType(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );
  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      allocationTransacionRawList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        Enums.ExpenseType.None
      );

      transactionItem.productTemplate.isNotAuto = false;
      if (transactionItem.productTemplate.id > 0) {
        transactionItem.account.id = 0;
        transactionItem.price.value = "0.00";
      }
      transactionItem.discount.value = "0.00";
      transactionItem.discount.discountTypeId = 0;

      let allocationTransacionItemRawList = transactionHelper.SetAllocationTransactionByFinanceType(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          allocationTransacionItemRawList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyDepositModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyGoodsReceiptModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyInvoiceReceiptModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyExpenseRecordToIncome(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.number;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = false;

  let allocationTransacionRawList = transactionHelper.SetAllocationTransactionByFinanceType(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );
  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      allocationTransacionRawList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        Enums.ExpenseType.None
      );

      transactionItem.productTemplate.isNotAuto = false;
      if (transactionItem.productTemplate.id > 0) {
        transactionItem.account.id = 0;
        transactionItem.price.value = "0.00";
      }
      transactionItem.discount.value = "0.00";
      transactionItem.discount.discountTypeId = 0;

      let allocationTransacionItemRawList = transactionHelper.SetAllocationTransactionByFinanceType(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          allocationTransacionItemRawList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}

function SetTransactionCurrencyForCreateTransactionByQuotation(transactionDetail, currencyExchangeRates) {
  let currencyExchangeRate = transactionDetail.transactionCurrency.currencyExchangeRates;
  if (transactionDetail.financeType == Enums.FinanceType.InFlow) {
    currencyExchangeRate = currencyExchangeRates.averageBuyingRatesTransfer;
  } else {
    currencyExchangeRate = currencyExchangeRates.averageSellingRates;
  }
  transactionDetail.transactionCurrency.toCurrencyCode = currencyExchangeRates.toCurrencyCode;
  transactionDetail.transactionCurrency.currencyExchangeRates = currencyExchangeRate;
  transactionDetail.transactionCurrency.currencyRatio = currencyExchangeRates.currencyExchangeRatio;
}
function SetReceiptForCreateCreditNote(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceId = transactionDetail.id;
  transaction.reference.referenceTypeId = Enums.TransactionType.Quotation;
  transaction.reference.referenceName = transactionDetail.number;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,

        transaction.transactionType,
        transaction.financeType,
        true
      );
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.isGetSuggestionCurrency = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}
function SetInvoiceForCreateCreditNote(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceId = transactionDetail.id;
  transaction.reference.referenceTypeId = Enums.TransactionType.Quotation;
  transaction.reference.referenceName = transactionDetail.number;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true
      );
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.isGetSuggestionCurrency = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}
function GetModelInvoice(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Invoice",
    transactionType: Enums.TransactionType.Invoice,
    isValidateError: true,
    transactionDisabled: false,
    financeType: Enums.FinanceType.InFlow,
    expenseType: Enums.ExpenseType.None,
    transactionItemType: Enums.TransactionItemType.None,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(false),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    isValidateCreditLimit: true,
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.Invoice, Enums.FinanceType.InFlow)
  );
  return model;
}
function SetEditDepositModel(
  transaction,
  transactionDetail,
  allocationList,
  quotationForCreateTransaction,
  settingQuotationPartial
) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.userId = transactionDetail.userId;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  const isPartialQuotation =
    transaction.reference.referenceTypeId === Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0 &&
    quotationForCreateTransaction &&
    quotationForCreateTransaction.quotationReferenceTransactionType &&
    quotationForCreateTransaction.quotationReferenceTransactionType !== Enums.QuotationReferenceTransactionType.None;

  if (isPartialQuotation) {
    let percent = -1;

    if (
      quotationForCreateTransaction.quotationReferenceTransactionType ===
      Enums.QuotationReferenceTransactionType.Percent
    ) {
      percent = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(
          transactionDetail.transactionCurrency.currencyNetAmount,
          quotationForCreateTransaction.transactionCurrency.currencyNetAmount
        ),
        100
      );
    }

    SetCreatePartialQuotation(
      transaction,
      quotationForCreateTransaction,
      quotationForCreateTransaction.quotationReferenceTransactionType,
      percent,
      settingQuotationPartial
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];

    if (
      isPartialQuotation &&
      quotationForCreateTransaction.quotationReferenceTransactionType !==
        Enums.QuotationReferenceTransactionType.Default
    ) {
      CombineReferenceQuotationItemsToTransactionEdit(
        transaction,
        transactionDetail,
        allocationList,
        quotationForCreateTransaction
      );
    } else {
      for (let transactionDetailItem of transactionDetail.transactionItems) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          true,
          transactionDetail.expenseType
        );

        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }

        transaction.transactionItemList.push(transactionItem);
      }
    }
  }
  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
  transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;
}
function SetEditPurchaseRequisitionModel(transaction, transactionDetail, allocationList) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.userId = transactionDetail.userId;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];

    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseType
      );

      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}

function SetEditGoodsReceiptModel(
  transaction,
  transactionDetail,
  allocationList,
  quotationForCreateTransaction,
  settingQuotationPartial
) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  if (quotationForCreateTransaction && quotationForCreateTransaction.date) {
    transaction.reference.referenceIssueDate = new Date(quotationForCreateTransaction.date).ToDateJsonString();
  }
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.userId = transactionDetail.userId;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  const isPartialQuotation =
    transaction.reference.referenceTypeId === Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0 &&
    quotationForCreateTransaction &&
    quotationForCreateTransaction.quotationReferenceTransactionType &&
    quotationForCreateTransaction.quotationReferenceTransactionType !== Enums.QuotationReferenceTransactionType.None;

  if (isPartialQuotation) {
    let percent = -1;

    if (
      quotationForCreateTransaction.quotationReferenceTransactionType ===
      Enums.QuotationReferenceTransactionType.Percent
    ) {
      percent = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(
          transactionDetail.transactionCurrency.currencyNetAmount,
          quotationForCreateTransaction.transactionCurrency.currencyNetAmount
        ),
        100
      );
    }

    SetCreatePartialQuotation(
      transaction,
      quotationForCreateTransaction,
      quotationForCreateTransaction.quotationReferenceTransactionType,
      percent,
      settingQuotationPartial
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];

    if (
      isPartialQuotation &&
      quotationForCreateTransaction.quotationReferenceTransactionType !==
        Enums.QuotationReferenceTransactionType.Default
    ) {
      CombineReferenceQuotationItemsToTransactionEdit(
        transaction,
        transactionDetail,
        allocationList,
        quotationForCreateTransaction
      );
    } else {
      for (let transactionDetailItem of transactionDetail.transactionItems) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          true,
          transactionDetail.expenseType
        );

        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }

        transaction.transactionItemList.push(transactionItem);
      }
    }
  }

  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}

function SetEditInvoiceReceiptModel(
  transaction,
  transactionDetail,
  allocationList,
  quotationForCreateTransaction,
  settingQuotationPartial
) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  if (quotationForCreateTransaction && quotationForCreateTransaction.date) {
    transaction.reference.referenceIssueDate = new Date(quotationForCreateTransaction.date).ToDateJsonString();
  }
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.userId = transactionDetail.userId;
  transaction.referenceDepositList = transactionDetail.referenceDepositList;
  transaction.referenceDepositSummary = transactionDetail.referenceDepositSummary;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  const isPartialQuotation =
    transaction.reference.referenceTypeId === Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0 &&
    quotationForCreateTransaction &&
    quotationForCreateTransaction.quotationReferenceTransactionType &&
    quotationForCreateTransaction.quotationReferenceTransactionType !== Enums.QuotationReferenceTransactionType.None;

  if (isPartialQuotation) {
    let percent = -1;

    if (
      quotationForCreateTransaction.quotationReferenceTransactionType ===
      Enums.QuotationReferenceTransactionType.Percent
    ) {
      percent = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(
          transactionDetail.transactionCurrency.currencyNetAmount,
          quotationForCreateTransaction.transactionCurrency.currencyNetAmount
        ),
        100
      );
    }

    SetCreatePartialQuotation(
      transaction,
      quotationForCreateTransaction,
      quotationForCreateTransaction.quotationReferenceTransactionType,
      percent,
      settingQuotationPartial
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    if (
      isPartialQuotation &&
      quotationForCreateTransaction.quotationReferenceTransactionType !==
        Enums.QuotationReferenceTransactionType.Default
    ) {
      CombineReferenceQuotationItemsToTransactionEdit(
        transaction,
        transactionDetail,
        allocationList,
        quotationForCreateTransaction
      );
    } else {
      for (let transactionDetailItem of transactionDetail.transactionItems) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          true,
          transactionDetail.transactionItemType
        );

        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }

        transaction.transactionItemList.push(transactionItem);
      }
    }
  }

  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}

function SetEditInvoiceModel(
  transaction,
  transactionDetail,
  allocationList,
  quotationForCreateTransaction,
  settingQuotationPartial
) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.transactionItemType
    ? transactionDetail.transactionItemType
    : transactionDetail.expenseType;
  transaction.transactionItemType = transactionDetail.transactionItemType
    ? transactionDetail.transactionItemType
    : transactionDetail.expenseType;
  transaction.userId = transactionDetail.userId;
  transaction.referenceDepositList = transactionDetail.referenceDepositList;
  transaction.referenceDepositSummary = transactionDetail.referenceDepositSummary;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  const isPartialQuotation =
    transaction.reference.referenceTypeId === Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0 &&
    quotationForCreateTransaction &&
    quotationForCreateTransaction.quotationReferenceTransactionType &&
    quotationForCreateTransaction.quotationReferenceTransactionType !== Enums.QuotationReferenceTransactionType.None;

  if (isPartialQuotation) {
    let percent = -1;

    if (
      quotationForCreateTransaction.quotationReferenceTransactionType ===
      Enums.QuotationReferenceTransactionType.Percent
    ) {
      percent = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(
          transactionDetail.transactionCurrency.currencyNetAmount,
          quotationForCreateTransaction.transactionCurrency.currencyNetAmount
        ),
        100
      );
    }

    SetCreatePartialQuotation(
      transaction,
      quotationForCreateTransaction,
      quotationForCreateTransaction.quotationReferenceTransactionType,
      percent,
      settingQuotationPartial
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];

    if (
      isPartialQuotation &&
      quotationForCreateTransaction.quotationReferenceTransactionType !==
        Enums.QuotationReferenceTransactionType.Default
    ) {
      CombineReferenceQuotationItemsToTransactionEdit(
        transaction,
        transactionDetail,
        allocationList,
        quotationForCreateTransaction
      );
    } else {
      for (let transactionDetailItem of transactionDetail.transactionItems) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          true,
          transactionDetail.transactionItemType
        );

        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }

        transaction.transactionItemList.push(transactionItem);
      }
    }
  }

  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  if (transaction.financeType === Enums.FinanceType.OutFlow) {
    transaction.payment = transactionDetail.payment;
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;
  }
}
function SetEditCreditNoteModel(transaction, transactionDetail, allocationList) {
  const isCreditNoteReference = transactionDetail.referenceId && transactionDetail.referenceId > 0;
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.status;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  if (isCreditNoteReference && transactionDetail.transactionCurrency) {
    transaction.reference.transactionCurrency = {
      currencyNetAmount: transactionDetail.transactionCurrency.currencyNetAmount,
      currencyVatTotal: transactionDetail.transactionCurrency.currencyVatTotal,
      currencyPreVatTotal: transactionDetail.transactionCurrency.currencyPreVatTotal,
      currencyZeroVatTotal: transactionDetail.transactionCurrency.currencyZeroVatTotal,
      currencyVatExemptedTotal: transactionDetail.transactionCurrency.currencyVatExemptedTotal,
      currencyWhtTotal: transactionDetail.transactionCurrency.currencyWhtTotal,
      currencySubTotalForCalculateWht: transactionDetail.transactionCurrency.currencySubTotalForCalculateWht,
    };
  }
  if (isCreditNoteReference && transactionDetail.transactionSummary) {
    transaction.reference.transactionSummary = {
      netAmount: transactionDetail.transactionSummary.netAmount,
      vatTotal: transactionDetail.transactionSummary.vatTotal,
      preVatTotal: transactionDetail.transactionSummary.preVatTotal,
      zeroVatTotal: transactionDetail.transactionSummary.zeroVatTotal,
      vatExemptedTotal: transactionDetail.transactionSummary.vatExemptedTotal,
      whtTotal: transactionDetail.transactionSummary.whtTotal,
      subTotalForCalculateWht: transactionDetail.transactionSummary.subTotalForCalculateWht,
      isServiceOnly: transactionDetail.transactionSummary.isServiceOnly,
    };
  }
  transaction.reasonType.value = { id: transactionDetail.creditNoteReasonId };
  transaction.reasonDescription.text = transactionDetail.creditNoteDescription;
  transaction.reasonDescription.isNotAuto = true;
  transaction.returnStock.value = { id: transactionDetail.isReturnStock ? 1 : 2 };
  transaction.transactionReferenceAmount.value = transactionDetail.referenceTransactionCurrencyAmount.FormatMoney();
  transaction.creditNoteWaitingPaidTotal.value = transactionDetail.creditNoteWaitingPaidTotal.FormatMoney();
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.userId = transactionDetail.userId;
  transaction.reduceDebtType.value.id = Enums.ReduceDebtType.None;
  if (isCreditNoteReference) {
    transaction.returnStock.disabled = true;
    transaction.contact.disabled = true;
    transaction.transactionItemDisabled = true;
    transaction.transactionCurrencySummary.disabled = true;
    transaction.transactionDiscount.disabled = true;
    transaction.reduceDebtType.value.id = Enums.ReduceDebtType.Partially;
  }
  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
  transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;
  transaction.isNotAuto = true;

  if (
    transaction.payment.paymentGroupList &&
    transaction.payment.paymentGroupList.length > 0 &&
    transactionDetail.referenceName &&
    transactionDetail.referenceId > 0
  ) {
    if (transactionDetail.creditNoteAmount.ToNumber() > 0) {
      transaction.payment.paymentOptionDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentActived = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionIsNotAuto = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionTypeDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionNumberDisabled = true;
      if (isCreditNoteReference) {
        transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionType.value =
          transactionDetail.referenceType;
        transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionNumber =
          transactionDetail.referenceName;
      }
    } else {
      transaction.payment.paymentOptionDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentDisabled = true;
    }

    if (transaction.creditNoteWaitingPaidTotal.value.ToNumber() == 0) {
      transaction.payment.paymentGroupList[0].paymentTransactionChartAccountDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionChartAccountHidden = true;
      transaction.payment.paymentGroupList[0].paymentTransactionBankAccountDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionBankAccountHidden = true;
      transaction.payment.paymentGroupList[0].whtPayment.hidden = true;
    }
  }
  if (
    transaction.payment &&
    transaction.payment.paymentGroupList &&
    transaction.payment.paymentGroupList.length > 0 &&
    transaction.financeType == Enums.FinanceType.OutFlow
  ) {
    transaction.payment.paymentGroupList.forEach((item) => {
      if (item.eWhtType == Enums.EWhtType.EWht) {
        item.paymentGroupTotal += item.eWhtData.whtAmount.ToNumber();
        item.paymentTransactionBankAccountTotalWithWht += item.eWhtData.whtAmount.ToNumber();
        transaction.payment.paymentAllGroupTotal += item.eWhtData.whtAmount.ToNumber();
      }
    });
  }
  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationTransactionList,
    allocationList,
    transaction.financeType
  );

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];

    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        !isCreditNoteReference,
        transactionDetail.expenseTypeId
      );

      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationTransactionList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }

      if (isCreditNoteReference) {
        transactionItem.checked.hidden = false;
        transactionItem.checked.disabled = false;
        transactionItem.description.disabled = false;
        transactionItem.amount.disabled = false;
        transactionItem.price.disabled = false;
        transactionItem.vatTypeId.disabled = false;
        transactionItem.discount.disabled = false;
      }

      transactionItem.isReturnStock = transactionDetailItem.isReturnStock;
      if (transactionItem.isReturnStock) {
        transaction.returnStock.disabled = false;
      }
      transactionItem.referenceTransactionProductId = transactionDetailItem.referenceTransactionProductId;
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;

  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();

  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();

  transaction.transactionCurrencySummary.fromCurrencyUId = transactionDetail.transactionCurrency.fromCurrencyUid;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;

  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;

  transaction.transactionCurrencySummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  transaction.transactionSummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;

  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }

  transaction.transactionSummary.paymentWht = {
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
    paymentNetAmount: peakUtility
      .PeakOperatorSubtract(
        transactionDetail.transactionSummary.netAmount,
        transactionDetail.transactionSummary.whtTotal
      )
      .FormatMoney(),
    isShow: transactionDetail.transactionSummary.whtTotal != 0,
  };

  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.netAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount = transactionDetail.transactionSummary.whtTotal;
}
function SetEditDebitNoteModel(transaction, transactionDetail, allocationList) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.status;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.reasonType.value = { id: transactionDetail.debitNoteReasonId };
  transaction.reasonDescription.text = transactionDetail.debitNoteDescription;
  transaction.reasonDescription.isNotAuto = true;
  transaction.returnStock.value = { id: transactionDetail.isReturnStock ? 1 : 2 };
  transaction.debitNoteAmount = transactionDetail.debitNoteAmount;
  transaction.transactionReferenceAmount.value = transactionDetail.referenceTransactionCurrencyAmount.FormatMoney();
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.contact.disabled = GetDisableContactByReference(transactionDetail);
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.expenseTypeId;
  transaction.userId = transactionDetail.userId;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationTransactionList,
    allocationList,
    transaction.financeType
  );

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];

    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseTypeId
      );

      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationTransactionList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
  if (
    transaction.payment &&
    transaction.payment.paymentGroupList &&
    transaction.payment.paymentGroupList.length > 0 &&
    transaction.financeType == Enums.FinanceType.InFlow
  ) {
    transaction.payment.paymentGroupList.forEach((item) => {
      if (item.eWhtType == Enums.EWhtType.EWht) {
        item.paymentGroupTotal += item.eWhtData.whtAmount.ToNumber();
        item.paymentTransactionBankAccountTotalWithWht += item.eWhtData.whtAmount.ToNumber();
        transaction.payment.paymentAllGroupTotal += item.eWhtData.whtAmount.ToNumber();
      }
    });
  }
  transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;
}
function SetDetailRecurringInvoiceModel(transaction, transactionDetail, allocationList) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.headerName =
    transactionDetail.financeTypeId == Enums.FinanceType.InFlow
      ? "Invoice"
      : transactionDetail.expenseTypeId == Enums.ExpenseType.Expense
      ? "Record_New_Expense"
      : "Purchase_Inventory_Record";
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.status;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.expenseType = transactionDetail.expenseTypeId;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseTypeId
      );
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  if (transactionDetail.receivedTaxInvoiceList && transactionDetail.receivedTaxInvoiceList.length > 0) {
    for (let receivedTaxInvoice of transactionDetail.receivedTaxInvoiceList) {
      transaction.receivedTaxInvoice.value.push(receivedTaxInvoice);
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.fromCurrencyUId = transactionDetail.transactionCurrency.fromCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  const currency = transactionHelper
    .GetCurrencyMenuList()
    .find((x) => x.value === transaction.transactionCurrencySummary.toCurrencyUId);
  transaction.transactionCurrencySummary.currencyCode = currency ? currency.currencyCode : "";
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  if (transaction.financeType === Enums.FinanceType.OutFlow) {
    transaction.payment = transactionDetail.payment;
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;
  }
}
function SetCopyInvoiceModel(transaction, transactionDetail, allocationList) {
  transaction.expenseType = transactionDetail.expenseType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.isValidateError = false;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseType
      );
      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }

  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}

function SetCopyRecurringInvoiceModel(transaction, transactionDetail, allocationList) {
  transaction.expenseType =
    transactionDetail.financeTypeId == Enums.FinanceType.OutFlow
      ? transactionDetail.expenseTypeId
      : transaction.expenseType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseTypeId
      );
      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyCreditNoteModel(transaction, transactionDetail, allocationList) {
  transaction.expenseType = transactionDetail.expenseType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.reasonType.value = { id: transactionDetail.creditNoteReasonId };
  transaction.reasonDescription.text = transactionDetail.creditNoteDescription;
  transaction.reasonDescription.isNotAuto = true;
  transaction.returnStock.value = { id: transactionDetail.isReturnStock ? 1 : 2 };
  transaction.transactionReferenceAmount.value = transactionDetail.referenceTransactionCurrencyAmount.FormatMoney();
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationTransactionList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];

    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseTypeId
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationTransactionList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }

  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function SetCopyDebitNoteModel(transaction, transactionDetail, allocationList) {
  transaction.expenseType = transactionDetail.expenseType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.reasonType.value = { id: transactionDetail.debitNoteReasonId };
  transaction.reasonDescription.text = transactionDetail.debitNoteDescription;
  transaction.reasonDescription.isNotAuto = true;
  transaction.returnStock.value = { id: transactionDetail.isReturnStock ? 1 : 2 };
  transaction.transactionReferenceAmount.value = transactionDetail.referenceTransactionCurrencyAmount.FormatMoney();
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationTransactionList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];

    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseTypeId
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationTransactionList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }

  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function CheckPackageCanUseAllocation() {
  let callCheckMerchantPackage = false;
  let startDate = new Date(process.env.VUE_APP_PackageStartDate);
  let nowDate = new Date();
  callCheckMerchantPackage = userHelper.CheckMerchantPackage([Enums.Package.Free]) && startDate <= nowDate;
  return callCheckMerchantPackage;
}

function SetAITransactionModel(transaction, transactionDetail, allocationList) {
  transaction.id = transactionDetail.id.ToNumber();
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.isNotAuto = false;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseType,
        transactionDetail.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }

  const currencyList = transactionItemHelper.GetCurrencyMenuList();
  const currencyCodeItem = currencyList.find((x) => x.value === transactionDetail.transactionCurrency.toCurrencyUid);
  transaction.transactionCurrencySummary.currencyCode = currencyCodeItem.currencyCode;
}
function SetAIChartOfAccount(
  transaction,
  contactId,
  aiSuggestionTransaction,
  transactionType,
  financeType,
  expenseType
) {
  transaction.contact.id = contactId;
  if (aiSuggestionTransaction.chartOfAccountList && aiSuggestionTransaction.chartOfAccountList.length > 0) {
    transaction.transactionItemList = [];
    for (let chartOfAccount of aiSuggestionTransaction.chartOfAccountList) {
      if (chartOfAccount.accountId > 0) {
        transaction.transactionItemList.push(
          transactionHelper.GetCreateTransactionItemForAIChartOfAccount(
            chartOfAccount.accountId,
            transactionType,
            financeType,
            expenseType
          )
        );
      }
    }
  }
}
function GetModelSellAssetReceipt(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Sell_Asset_Receipt",
    transactionType: Enums.TransactionType.Receipt,
    financeType: Enums.FinanceType.InFlow,
    transactionItemType: Enums.TransactionItemType.Asset,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      paymentGroupId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Receipt,
      Enums.FinanceType.InFlow,
      Enums.ExpenseType.None,
      Enums.TransactionItemType.Asset
    )
  );
  return model;
}
function GetModelReceipt(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Receipt",
    transactionType: Enums.TransactionType.Receipt,
    financeType: Enums.FinanceType.InFlow,
    transactionItemType: Enums.TransactionItemType.None,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      paymentGroupId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };

  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.Receipt, Enums.FinanceType.InFlow)
  );

  return model;
}
function SetCreateReceiptFromBillingNote(transaction, transactionDetail) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = Enums.TransactionType.BillingNote;
  transaction.reference.paymentGroupId = transactionDetail.paymentGroupId;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.contact.disabled = true;
  transaction.taxStatus.hidden = true;
  transaction.taxStatus.isNotAuto = true;
  transaction.transactionCurrencySummary.disabled = true;
  transaction.isNotCalculateTransactionSummary = true;
  transaction.isNotAuto = true;
  transaction.isValidateError = false;
  transaction.isBillingNoteTransaction = true;
  transaction.transactionDisabled = true;
  transaction.payment = transactionDetail.payment;
  if (transaction.payment && transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    transaction.payment.paymentGroupList.forEach((item) => {
      if (item.eWhtType == Enums.EWhtType.EWht) {
        item.whtPayment = item.eWhtData;
      }
    });
  }
  transaction.billingNoteTransactionList = transactionDetail.billingNoteTransactionList;
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.ToPeakTransactionItemFormat();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.fromCurrencyUId = transactionDetail.transactionCurrency.fromCurrencyUid;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate = transactionDetail.transactionCurrency.currencyExchangeRates;
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.whtTotal = transactionDetail.transactionCurrency.currencyWhtTotal;
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;

  transaction.transactionCurrencySummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  transaction.transactionSummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  transaction.transactionSummary.paymentWht = {
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
    paymentNetAmount: peakUtility
      .PeakOperatorSubtract(
        transactionDetail.transactionSummary.netAmount,
        transactionDetail.transactionSummary.whtTotal
      )
      .FormatMoney(),
    isShow: transactionDetail.transactionSummary.whtTotal != 0,
  };
  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.netAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount = transactionDetail.transactionSummary.whtTotal;

  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
}
function SetCreateCreditNoteModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.reference.paymentGroupId = transactionDetail.paymentGroupId;
  transaction.reduceDebtType.value.id = Enums.ReduceDebtType.AllDebts;
  if (transactionDetail.transactionCurrency) {
    transaction.reference.transactionCurrency = {
      currencyNetAmount: transactionDetail.transactionCurrency.currencyNetAmount,
      currencyVatTotal: transactionDetail.transactionCurrency.currencyVatTotal,
      currencyPreVatTotal: transactionDetail.transactionCurrency.currencyPreVatTotal,
      currencyZeroVatTotal: transactionDetail.transactionCurrency.currencyZeroVatTotal,
      currencyVatExemptedTotal: transactionDetail.transactionCurrency.currencyVatExemptedTotal,
      currencyWhtTotal: transactionDetail.transactionCurrency.currencyWhtTotal,
      currencySubTotalForCalculateWht: transactionDetail.transactionCurrency.currencySubTotalForCalculateWht,
    };
  }
  if (transactionDetail.transactionSummary) {
    transaction.reference.transactionSummary = {
      netAmount: transactionDetail.transactionSummary.netAmount,
      vatTotal: transactionDetail.transactionSummary.vatTotal,
      preVatTotal: transactionDetail.transactionSummary.preVatTotal,
      zeroVatTotal: transactionDetail.transactionSummary.zeroVatTotal,
      vatExemptedTotal: transactionDetail.transactionSummary.vatExemptedTotal,
      whtTotal: transactionDetail.transactionSummary.whtTotal,
      subTotalForCalculateWht: transactionDetail.transactionSummary.subTotalForCalculateWht,
      isServiceOnly: transactionDetail.transactionSummary.isServiceOnly,
    };
  }
  transaction.reasonType.value = { id: transactionDetail.creditNoteReasonId };
  transaction.reasonDescription.text = transactionDetail.creditNoteDescription;
  transaction.returnStock.value = { id: transactionDetail.isReturnStock ? 1 : 2 };
  transaction.returnStock.disabled = true;
  transaction.transactionReferenceAmount.value = transactionDetail.referenceTransactionCurrencyAmount.FormatMoney();
  transaction.creditNoteWaitingPaidTotal.value = transactionDetail.creditNoteWaitingPaidTotal.FormatMoney();
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.contact.disabled = true;
  transaction.transactionItemDisabled = true;
  transaction.isValidateError = false;
  transaction.transactionCurrencySummary.disabled = true;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
  transaction.isNotAuto = true;
  if (
    transaction.payment.paymentGroupList &&
    transaction.payment.paymentGroupList.length > 0 &&
    transactionDetail.referenceName &&
    transactionDetail.referenceId > 0
  ) {
    if (transactionDetail.creditNoteAmount.ToAccountingRoundUpNumber() > 0) {
      transaction.payment.paymentOptionDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentActived = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionType.value =
        transactionDetail.referenceType;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionNumber =
        transactionDetail.referenceName;

      transaction.payment.paymentGroupList[0].paymentTransactionDocumentDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionTypeDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentList[0].transactionNumberDisabled = true;
    } else {
      transaction.payment.paymentOptionDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionDocumentDisabled = true;
    }

    if (transaction.creditNoteWaitingPaidTotal.value.ToNumber() == 0) {
      transaction.payment.paymentGroupList[0].paymentTransactionChartAccountDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionChartAccountHidden = true;
      transaction.payment.paymentGroupList[0].paymentTransactionBankAccountDisabled = true;
      transaction.payment.paymentGroupList[0].paymentTransactionBankAccountHidden = true;
      transaction.payment.paymentGroupList[0].whtPayment.hidden = true;
    }
  }

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationTransactionList,
      allocationList,
      transaction.financeType
    );
  }

  let transactionPaymentRatio =
    transaction.reference.paymentGroupId > 0
      ? peakUtility.PeakOperatorDivide(
          transaction.payment.paymentAllGroupTotal,
          transactionDetail.transactionSummary.netAmount
        )
      : 1;

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        false,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationTransactionList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }
      transactionItem.checked.value = true;
      transactionItem.checked.disabled = true;
      transactionItem.checked.hidden = false;
      transactionItem.description.text = transactionItem.referenceDescription;
      transactionItem.description.disabled = false;
      transactionItem.amount.value = transactionItem.referenceAmount;
      transactionItem.price.value = transactionItem.referencePrice;
      transactionItem.discount.value = transactionItem.referenceDiscount;
      transactionItem.discount.discountTypeId = transactionItem.referenceDiscountType;
      transactionItem.referenceTransactionProductId = transactionDetailItem.referenceTransactionProductId;
      transactionItem.isReturnStock = transactionDetailItem.isReturnStock;

      if (transactionItem.isReturnStock) {
        transaction.returnStock.disabled = false;
      }

      if (transactionItem.itemWht.value != null) {
        transactionItem.itemWht.value = peakUtility.PeakOperatorMultiply(
          transactionItem.itemWht.value,
          transactionPaymentRatio
        );
      }
      transaction.transactionItemList.push(transactionItem);
    }

    if (transactionPaymentRatio != 1) {
      let transactionPartialDescription = transactionHelper.GetCreateTransactionItemDefualt(
        transaction.transactionType,
        transaction.financeType
      );
      transactionPartialDescription.isDescriptionOnly = true;
      transactionPartialDescription.description.disabled = true;
      transactionPartialDescription.description.text = i18n.t("Receipt_Partial_Description", {
        paid: transaction.payment.paymentAllGroupTotal.FormatMoney(),
        amount: transactionDetail.transactionSummary.netAmount.FormatMoney(),
      });
      transaction.transactionItemList.push(transactionPartialDescription);
    }
  }

  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.transactionDiscount.value =
    transactionDetail.discountType === Enums.DiscountType.Currency
      ? peakUtility
          .PeakOperatorMultiply(transactionDetail.discount, transactionPaymentRatio)
          .ToPeakTransactionItemFormat()
      : transactionDetail.discount;
  transaction.transactionDiscount.disabled = true;

  transaction.transactionSummary.netAmount = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.netAmount, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatExemptedTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.zeroVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.zeroVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.preVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.preVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyPreVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyPreVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.vatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatExemptedTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyZeroVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.netAmount = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyNetAmount, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.fromCurrencyUId = transactionDetail.transactionCurrency.fromCurrencyUid;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.isGetSuggestionCurrency = false;

  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;

  transaction.transactionCurrencySummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  transaction.transactionSummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  if (
    transactionDetail.isCreatedTaxInvoice ||
    transaction.transactionSummary.sameProductVatType !== Enums.ProductVatType.None
  ) {
    transaction.issueTaxInvoice.value = true;
    transaction.issueTaxInvoice.isNotAuto = true;
  }

  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  transaction.transactionSummary.paymentWht = {
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
    paymentNetAmount: peakUtility
      .PeakOperatorSubtract(
        transactionDetail.transactionSummary.netAmount,
        transactionDetail.transactionSummary.whtTotal
      )
      .FormatMoney(),
    isShow: transactionDetail.transactionSummary.whtTotal != 0,
  };
  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.netAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount = transactionDetail.transactionSummary.whtTotal;
}

function SetCreateDebitNoteModel(transaction, transactionDetail, allocationList) {
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.reference.paymentGroupId = transactionDetail.paymentGroupId;
  transaction.reasonType.value = { id: transactionDetail.debitNoteReasonId };
  transaction.reasonDescription.text = transactionDetail.debitNoteDescription;
  transaction.returnStock.value = { id: transactionDetail.isReturnStock ? 1 : 2 };
  transaction.transactionReferenceAmount.value = transactionDetail.referenceTransactionCurrencyAmount.FormatMoney();
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.contact.disabled = true;
  transaction.isValidateError = false;
  // transaction.transactionItemDisabled = true;
  transaction.transactionCurrencySummary.disabled = true;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationTransactionList,
      allocationList,
      transaction.financeType
    );
  }

  let transactionPaymentRatio =
    transaction.reference.paymentGroupId > 0
      ? peakUtility.PeakOperatorDivide(
          transaction.payment.paymentAllGroupTotal,
          transactionDetail.transactionSummary.netAmount
        )
      : 1;

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        false,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationTransactionList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transactionItem.checked.value = false;
      transactionItem.checked.hidden = false;
      transactionItem.amount.value = "0.00";
      transactionItem.price.value = "0.00";
      transactionItem.discount.value = "0.00";
      transactionItem.discount.discountTypeId = Enums.DiscountType.Currency;
      transactionItem.referenceTransactionProductId = transactionDetailItem.referenceTransactionProductId;

      transaction.transactionItemList.push(transactionItem);
    }

    if (transactionPaymentRatio != 1) {
      let transactionPartialDescription = transactionHelper.GetCreateTransactionItemDefualt(
        transaction.transactionType,
        transaction.financeType
      );
      transactionPartialDescription.isDescriptionOnly = true;
      transactionPartialDescription.description.disabled = true;
      transactionPartialDescription.description.text = i18n.t("Receipt_Partial_Description", {
        paid: transaction.payment.paymentAllGroupTotal.FormatMoney(),
        amount: transactionDetail.transactionSummary.netAmount.FormatMoney(),
      });
      transaction.transactionItemList.push(transactionPartialDescription);
    }
  }

  transaction.transactionDiscount.discountType = Enums.DiscountType.Currency;
  transaction.transactionDiscount.value = "0.00";

  transaction.transactionSummary.netAmount = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.netAmount, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatExemptedTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.zeroVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.zeroVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.preVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.preVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyPreVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyPreVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.vatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatExemptedTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyZeroVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.netAmount = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyNetAmount, transactionPaymentRatio)
    .FormatMoney();

  transaction.transactionCurrencySummary.fromCurrencyUId = transactionDetail.transactionCurrency.fromCurrencyUid;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;

  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;

  transaction.transactionCurrencySummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  transaction.transactionSummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;

  if (
    transactionDetail.isCreatedTaxInvoice ||
    transaction.transactionSummary.sameProductVatType !== Enums.ProductVatType.None
  ) {
    transaction.issueTaxInvoice.value = true;
    transaction.issueTaxInvoice.isNotAuto = true;
  }

  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;

  transaction.transactionSummary.paymentWht = {
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
    paymentNetAmount: peakUtility
      .PeakOperatorSubtract(
        transactionDetail.transactionSummary.netAmount,
        transactionDetail.transactionSummary.whtTotal
      )
      .FormatMoney(),
    isShow: transactionDetail.transactionSummary.whtTotal != 0,
  };
  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.netAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount = transactionDetail.transactionSummary.whtTotal;

  transactionHelper.CalculatePreVatTotalFromEditVatTransaction(transaction);
  transactionHelper.SetTransactionSummary(transaction);

  transaction.isNotAuto = true;
}

function SetCreateReceiptFromInvoice(transaction, transactionDetail, allocationList) {
  const transactionDate = dayjs(transactionDetail.date || "").format();
  const isValidDate = dayjs(transactionDate).isValid();

  if (isValidDate) {
    transaction.minDate = transactionDate;
    const isTodateMoreThanTransactionDate = dayjs().diff(transactionDate, "day") > 0;
    if (!isTodateMoreThanTransactionDate) {
      transaction.date.value = transaction.minDate;
    }
  }

  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = Enums.TransactionType.Invoice;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = "";
  transaction.contact.disabled = true;
  transaction.isValidateError = false;
  transaction.transactionItemDisabled = true;
  transaction.transactionCurrencySummary.disabled = true;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.transactionDisabled = true;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.referenceDepositList = transactionDetail.referenceDepositList;
  transaction.referenceDepositSummary = transactionDetail.referenceDepositSummary;
  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transaction.payment && transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    transaction.payment.paymentGroupList.forEach((item) => {
      if (item.eWhtType == Enums.EWhtType.EWht) {
        item.paymentGroupTotal += item.eWhtData.whtAmount.ToNumber();
        item.paymentTransactionBankAccountTotalWithWht += item.eWhtData.whtAmount.ToNumber();
        transaction.payment.paymentAllGroupTotal += item.eWhtData.whtAmount.ToNumber();
      }
    });
  }

  let transactionPaymentRatio =
    transaction.reference.paymentGroupId > 0
      ? peakUtility.PeakOperatorDivide(
          transaction.payment.paymentAllGroupTotal,
          transactionDetail.transactionSummary.netAmount
        )
      : 1;

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        false,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transactionItem.price.value = peakUtility
        .PeakOperatorMultiply(transactionItem.price.value, transactionPaymentRatio)
        .ToPeakTransactionItemFormat();
      if (transactionItem.discount.discountTypeId === Enums.DiscountType.Currency) {
        transactionItem.discount.value = peakUtility
          .PeakOperatorMultiply(transactionItem.discount.value, transactionPaymentRatio)
          .ToPeakTransactionItemFormat();
      }
      if (transactionItem.itemWht.value != null) {
        transactionItem.itemWht.value = peakUtility.PeakOperatorMultiply(
          transactionItem.itemWht.value,
          transactionPaymentRatio
        );
      }
      transaction.transactionItemList.push(transactionItem);
    }

    if (transactionPaymentRatio != 1) {
      let transactionPartialDescription = transactionHelper.GetCreateTransactionItemDefualt(
        transaction.transactionType,
        transaction.financeType
      );
      transactionPartialDescription.isDescriptionOnly = true;
      transactionPartialDescription.description.disabled = true;
      transactionPartialDescription.description.text = i18n.t("Receipt_Partial_Description", {
        paid: transaction.payment.paymentAllGroupTotal.FormatMoney(),
        amount: transactionDetail.transactionSummary.netAmount.FormatMoney(),
      });
      transaction.transactionItemList.push(transactionPartialDescription);
    }
  }

  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.transactionDiscount.value =
    transactionDetail.discountType === Enums.DiscountType.Currency
      ? peakUtility
          .PeakOperatorMultiply(transactionDetail.discount, transactionPaymentRatio)
          .ToPeakTransactionItemFormat()
      : transactionDetail.discount;
  transaction.transactionDiscount.disabled = true;

  transaction.transactionSummary.discount =
    transactionDetail.discountType === Enums.DiscountType.Currency
      ? peakUtility
          .PeakOperatorMultiply(transactionDetail.transactionSummary.discount, transactionPaymentRatio)
          .ToPeakTransactionItemFormat()
      : transactionDetail.transactionSummary.discount;

  transaction.transactionCurrencySummary.discount =
    transactionDetail.discountType === Enums.DiscountType.Currency
      ? peakUtility
          .PeakOperatorMultiply(transactionDetail.transactionCurrency.discount, transactionPaymentRatio)
          .ToPeakTransactionItemFormat()
      : transactionDetail.transactionCurrency.discount;

  transaction.transactionSummary.netAmount = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.netAmount, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatExemptedTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.zeroVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.zeroVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.preVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.preVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyPreVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyPreVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.vat.vatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.vatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionSummary.subTotalForCalculateWht = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionSummary.subTotalForCalculateWht, transactionPaymentRatio)
    .ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyVatExemptedTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyZeroVatTotal, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.netAmount = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyNetAmount, transactionPaymentRatio)
    .FormatMoney();
  transaction.transactionCurrencySummary.whtTotal = peakUtility
    .PeakOperatorMultiply(transactionDetail.transactionCurrency.currencyWhtTotal, transactionPaymentRatio)
    .FormatMoney();

  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;

  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transaction.transactionCurrencySummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
  transaction.transactionSummary.vat.disabled =
    transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;

  transaction.transactionSummary.paymentWht = {
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
    paymentNetAmount: peakUtility
      .PeakOperatorSubtract(
        transactionDetail.transactionSummary.netAmount,
        transactionDetail.transactionSummary.whtTotal
      )
      .FormatMoney(),
    isShow: transactionDetail.transactionSummary.whtTotal != 0,
  };
  transaction.transactionSummary.remainPaymentNetAmount = transaction.transactionSummary.netAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount = transactionDetail.transactionSummary.whtTotal;
  transaction.transactionCurrencySummary.amountBeforeDiscount =
    transactionDetail.transactionCurrency.amountBeforeDiscount.FormatMoney();
  transaction.transactionCurrencySummary.referenceDepositTotal =
    transactionDetail.transactionCurrency.referenceDepositTotal.FormatMoney();
  transaction.transactionCurrencySummary.amountAfterDiscount =
    transactionDetail.transactionCurrency.amountAfterDiscount.FormatMoney();

  transaction.isNotCalculateTransactionSummary = true;
  transaction.isNotAuto = true;
}
function SetDetailRecurringReceiptModel(transaction, transactionDetail, allocationList) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.status;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true
      );
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isBillingNoteTransaction = transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote;
  if (
    transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote ||
    transaction.reference.referenceTypeId === Enums.TransactionType.Invoice
  ) {
    transaction.contact.disabled = true;
    transaction.reference.disabled = true;
    transaction.isValidateError = false;
    transaction.transactionItemDisabled = true;
    transaction.transactionCurrencySummary.disabled = true;
    transaction.transactionDisabled = true;
    transaction.transactionSummary.vat.disabled = true;
    transaction.transactionCurrencySummary.vat.disabled = true;
    if (transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote) {
      transaction.isNotCalculateTransactionSummary = true;
    }
  }

  transaction.billingNoteTransactionList = transactionDetail.billingNoteTransactionList;
  transaction.isNotAuto = true;

  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.fromCurrencyUId = transactionDetail.transactionCurrency.fromCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  const currency = transactionHelper
    .GetCurrencyMenuList()
    .find((x) => x.value === transaction.transactionCurrencySummary.toCurrencyUId);
  transaction.transactionCurrencySummary.currencyCode = currency ? currency.currencyCode : "";
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
  transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;

  if (transaction.payment && transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    transaction.payment.paymentGroupList.forEach((item) => {
      if (item.eWhtType == Enums.EWhtType.EWht) {
        item.paymentGroupTotal += item.eWhtData.whtAmount.ToNumber();
        item.paymentTransactionBankAccountTotalWithWht += item.eWhtData.whtAmount.ToNumber();
        transaction.payment.paymentAllGroupTotal += item.eWhtData.whtAmount.ToNumber();
      }
    });
  }
}
function SetEditReceiptModel(
  transaction,
  transactionDetail,
  allocationList,
  quotationForCreateTransaction,
  settingQuotationPartial
) {
  let isCanEdit = false;

  if (
    transactionDetail.referenceType == Enums.ReceiptReferenceType.None ||
    transactionDetail.referenceType == Enums.ReceiptReferenceType.Quotation ||
    transaction.referenceType == Enums.ReceiptReferenceType.Quotation
  ) {
    isCanEdit = true;
  }
  transaction.userId = transactionDetail.userId;
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.paymentGroupId = transactionDetail.referencePaymentGroupId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.referenceDepositList = transactionDetail.referenceDepositList;
  transaction.referenceDepositSummary = transactionDetail.referenceDepositSummary;

  transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
    transactionDetail.allocationList,
    allocationList,
    transaction.financeType
  );

  const isPartialQuotation =
    transaction.reference.referenceTypeId === Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0 &&
    quotationForCreateTransaction &&
    quotationForCreateTransaction.quotationReferenceTransactionType &&
    quotationForCreateTransaction.quotationReferenceTransactionType !== Enums.QuotationReferenceTransactionType.None;

  if (isPartialQuotation) {
    let percent = -1;

    if (
      quotationForCreateTransaction.quotationReferenceTransactionType ===
      Enums.QuotationReferenceTransactionType.Percent
    ) {
      percent = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(
          transactionDetail.transactionCurrency.currencyNetAmount,
          quotationForCreateTransaction.transactionCurrency.currencyNetAmount
        ),
        100
      );
    }

    SetCreatePartialQuotation(
      transaction,
      quotationForCreateTransaction,
      quotationForCreateTransaction.quotationReferenceTransactionType,
      percent,
      settingQuotationPartial
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];

    if (
      isPartialQuotation &&
      quotationForCreateTransaction.quotationReferenceTransactionType !==
        Enums.QuotationReferenceTransactionType.Default
    ) {
      CombineReferenceQuotationItemsToTransactionEdit(
        transaction,
        transactionDetail,
        allocationList,
        quotationForCreateTransaction
      );
    } else {
      for (let transactionDetailItem of transactionDetail.transactionItems) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          isCanEdit,
          transaction.expenseType,
          transaction.transactionItemType
        );

        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }

        transaction.transactionItemList.push(transactionItem);
      }
    }
  }

  transaction.isBillingNoteTransaction = transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote;
  transaction.billingNoteTransactionList = transactionDetail.billingNoteTransactionList;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  transaction.transactionSummary.discount = transactionDetail.transactionSummary.discount;
  transaction.transactionCurrencySummary.discount = transactionDetail.transactionCurrency.discount;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  transaction.transactionCurrencySummary.whtTotal =
    transactionDetail.transactionCurrency.currencyWhtTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;
  transaction.transactionSummary.remainPaymentNetAmount = transaction.transactionSummary.netAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount = transactionDetail.transactionSummary.whtTotal;
  transaction.transactionSummary.paymentWht = {
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
    paymentNetAmount: peakUtility
      .PeakOperatorSubtract(
        transactionDetail.transactionSummary.netAmount,
        transactionDetail.transactionSummary.whtTotal
      )
      .FormatMoney(),
    isShow: transactionDetail.transactionSummary.whtTotal != 0,
  };

  transaction.transactionCurrencySummary.amountBeforeDiscount =
    transactionDetail.transactionCurrency.amountBeforeDiscount.FormatMoney();
  transaction.transactionCurrencySummary.referenceDepositTotal =
    transactionDetail.transactionCurrency.referenceDepositTotal.FormatMoney();
  transaction.transactionCurrencySummary.amountAfterDiscount =
    transactionDetail.transactionCurrency.amountAfterDiscount.FormatMoney();

  transaction.payment = transactionDetail.payment;
  paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
  transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;

  if (transaction.payment && transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    transaction.payment.paymentGroupList.forEach((item) => {
      if (item.eWhtType == Enums.EWhtType.EWht) {
        item.paymentGroupTotal += item.eWhtData.whtAmount.ToNumber();
        item.paymentTransactionBankAccountTotalWithWht += item.eWhtData.whtAmount.ToNumber();
        transaction.payment.paymentAllGroupTotal += item.eWhtData.whtAmount.ToNumber();
      }
    });
  }

  if (
    transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote ||
    transaction.reference.referenceTypeId === Enums.TransactionType.Invoice
  ) {
    transaction.contact.disabled = true;
    transaction.isValidateError = false;
    transaction.transactionItemDisabled = true;
    transaction.transactionCurrencySummary.disabled = true;
    transaction.transactionDisabled = true;
    transaction.transactionSummary.vat.disabled = true;
    transaction.transactionCurrencySummary.vat.disabled = true;
    if (
      transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote ||
      transaction.reference.referenceTypeId === Enums.TransactionType.Invoice
    ) {
      transaction.isNotCalculateTransactionSummary = true;
    }
  }
  transaction.isNotAuto = true;
}

function SetCopyReceiptModel(transaction, transactionDetail, allocationList) {
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.isValidateError = false;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }

  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}

function SetCopyRecurringReceiptModel(transaction, transactionDetail, allocationList) {
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      if (!CheckPackageCanUseAllocation()) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          transactionDetailItem.allocationList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
        }
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.issueTaxInvoice.isNotAuto = true;
  transaction.issueTaxDocument.value = transactionDetail.isTaxDocument;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transactionHelper.SetTransactionSummary(transaction);
  transaction.isNotAuto = true;
}
function GetModelTaxInvoiceDefualt(createOrEdit) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: true,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Menu_SalesTaxInvoice",
    transactionType: Enums.TransactionType.TaxInvoice,
    financeType: Enums.FinanceType.InFlow,
    isValidateError: true,
    transactionDisabled: true,
    transactionItemType: Enums.TransactionItemType.Inventory,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: true,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: true,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(true),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(true),
    transactionItemList: [],
    transactionItemDisabled: true,
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.TaxInvoice, Enums.FinanceType.InFlow)
  );
  return model;
}
function SetCreateTaxInvoiceModel(transaction, transactionDetail) {
  const transactionDate = dayjs(transactionDetail.date || "").format();
  const isValidDate = dayjs(transactionDate).isValid();

  if (isValidDate) {
    transaction.minDate = transactionDate;
    const isTodateMoreThanTransactionDate = dayjs().diff(transactionDate, "day") > 0;
    if (!isTodateMoreThanTransactionDate) {
      transaction.date.value = transaction.minDate;
    }
  }

  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceName;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.remark.text = transactionDetail.remark;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountTypeId;
  transaction.contact.id = transactionDetail.contact.id;
  transaction.contact.contactCode = transactionDetail.contact.contactCode;
  transaction.contact.disabled = true;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.taxStatus.disabled = true;
  transaction.isNotAuto = true;
  transaction.isBillingNoteTransaction = transactionDetail.isBillingNoteTransaction;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.referenceDepositSummary = transactionDetail.referenceDepositSummary;
  if (transaction.isBillingNoteTransaction) {
    transaction.billingNoteTransactionList = transactionDetail.billingNoteTransactionList;
  } else {
    if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
      transaction.transactionItemList = [];
      for (let transactionDetailItem of transactionDetail.transactionItemList) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          false,
          transaction.expenseType,
          transaction.transactionItemType
        );
        transaction.transactionItemList.push(transactionItem);
      }
    }
  }
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate = transactionDetail.transactionCurrency.currencyExchangeRates;
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;

  transaction.transactionCurrencySummary.amountBeforeDiscount =
    transactionDetail.transactionCurrency.amountBeforeDiscount.FormatMoney();
  transaction.transactionCurrencySummary.referenceDepositTotal =
    transactionDetail.transactionCurrency.referenceDepositTotal.FormatMoney();
  transaction.transactionCurrencySummary.amountAfterDiscount =
    transactionDetail.transactionCurrency.amountAfterDiscount.FormatMoney();
}
function SetEditTaxInvoiceModel(transaction, transactionDetail) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.reference.referenceNumber = transactionDetail.referenceNumber;
  transaction.reference.referenceId = transactionDetail.referenceId;
  transaction.reference.referenceTypeId = transactionDetail.referenceType;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountTypeId;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.contact.disabled = true;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.taxStatus.disabled = true;
  transaction.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.userId = transactionDetail.userId;
  transaction.isBillingNoteTransaction = transactionDetail.isBillingNoteTransaction;
  transaction.transactionItemType = transactionDetail.transactionItemType;
  transaction.referenceDepositSummary = transactionDetail.referenceDepositSummary;
  if (transaction.isBillingNoteTransaction) {
    transaction.billingNoteTransactionList = transactionDetail.billingNoteTransactionList;
  } else {
    if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
      transaction.transactionItemList = [];
      for (let transactionDetailItem of transactionDetail.transactionItems) {
        let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
          transactionDetailItem,
          transaction.transactionType,
          transaction.financeType,
          false,
          transaction.expenseType,
          transaction.transactionItemType
        );
        transaction.transactionItemList.push(transactionItem);
      }
    }
  }
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();

  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;

  transaction.transactionCurrencySummary.amountBeforeDiscount =
    transactionDetail.transactionCurrency.amountBeforeDiscount.FormatMoney();
  transaction.transactionCurrencySummary.referenceDepositTotal =
    transactionDetail.transactionCurrency.referenceDepositTotal.FormatMoney();
  transaction.transactionCurrencySummary.amountAfterDiscount =
    transactionDetail.transactionCurrency.amountAfterDiscount.FormatMoney();
}
function GetModelSellAssetInvoice(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Sell_Asset_Invoice",
    transactionType: Enums.TransactionType.Invoice,
    isValidateError: true,
    transactionDisabled: false,
    financeType: Enums.FinanceType.InFlow,
    expenseType: Enums.ExpenseType.PurchaseAsset,
    transactionItemType: Enums.TransactionItemType.Asset,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(false),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    isValidateCreditLimit: true,
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Invoice,
      Enums.FinanceType.InFlow,
      Enums.ExpenseType.PurchaseAsset
    )
  );
  return model;
}
function GetModelCreditNote(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Credit_Note",
    transactionType: Enums.TransactionType.CreditNote,
    financeType: Enums.FinanceType.InFlow,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: true,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionReferenceAmount: {
      value: "0.00",
      isActive: false,
      disabled: false,
      validateError: false,
    },
    creditNoteWaitingPaidTotal: {
      value: "0.00",
    },
    reasonType: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    reasonDescription: {
      text: "",
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    returnStock: {
      value: { id: 1 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    reduceDebtType: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
      hidden: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.CreditNote, Enums.FinanceType.InFlow)
  );
  return model;
}
function GetModelDebitNote(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Debit_Note",
    transactionType: Enums.TransactionType.DebitNote,
    financeType: Enums.FinanceType.InFlow,
    isValidateError: true,
    transactionDisabled: false,
    debitNoteAmount: 0,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    reasonType: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    reasonDescription: {
      text: "",
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    returnStock: {
      value: { id: 1 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    transactionReferenceAmount: {
      value: "0.00",
      isActive: false,
      disabled: false,
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.DebitNote, Enums.FinanceType.InFlow)
  );
  return model;
}
function GetModelBillingNote(createOrEdit, financeType) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: financeType == Enums.FinanceType.InFlow ? "Menu_BillingNote" : "Menu_CombinedPaymentNote",
    transactionType: Enums.TransactionType.BillingNote,
    financeType: financeType,
    isValidateError: false,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(financeType == Enums.FinanceType.InFlow ? false : true),
    transactionItemDisabled: false,
    tagList: [],
    fileList: [],
    isAllowDupplicateReceivedBillingNoteNumber: false,
    isValidateCreditLimit: true,
  };

  return model;
}
function GetModelPurchaseOrder(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Purchase_Order",
    transactionType: Enums.TransactionType.Quotation,
    financeType: Enums.FinanceType.OutFlow,
    transactionItemType: Enums.TransactionItemType.Inventory,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.Quotation, Enums.FinanceType.OutFlow)
  );
  return model;
}
function GetModelPurchaseOrderAsset(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Purchase_Order_Asset",
    transactionType: Enums.TransactionType.Quotation,
    financeType: Enums.FinanceType.OutFlow,
    transactionItemType: Enums.TransactionItemType.Asset,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Quotation,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.None,
      Enums.TransactionItemType.Asset
    )
  );
  return model;
}
function GetModelDeposit(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Deposit_Receipt",
    transactionType: Enums.TransactionType.Deposit,
    isValidateError: true,
    financeType: Enums.FinanceType.InFlow,
    expenseType: Enums.ExpenseType.None,
    transactionDisabled: false,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: true,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(false, true),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Deposit,
      Enums.FinanceType.InFlow,
      Enums.ExpenseType.None
    )
  );
  return model;
}
function GetModelExpense(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Record_New_Expense",
    transactionType: Enums.TransactionType.Invoice,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.Expense,
    transactionItemType: Enums.TransactionItemType.Service,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Invoice,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.Expense
    )
  );
  return model;
}
function GetModelPurchaseInventory(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Purchase_Inventory_Record",
    transactionType: Enums.TransactionType.Invoice,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.PurchaseInventory,
    transactionItemType: Enums.TransactionItemType.Inventory,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Valid_Until",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Invoice,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.PurchaseInventory
    )
  );
  return model;
}
function GetModelPurchaseAsset(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Purchase_Asset_Record",
    transactionType: Enums.TransactionType.Invoice,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.PurchaseAsset,
    transactionItemType: Enums.TransactionItemType.Asset,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Invoice,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.PurchaseAsset
    )
  );
  return model;
}
function GetModelReceivedCreditNote(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Receive_Credit_Note",
    transactionType: Enums.TransactionType.CreditNote,
    financeType: Enums.FinanceType.OutFlow,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: true,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionReferenceAmount: {
      value: "0.00",
      isActive: false,
      disabled: false,
      validateError: false,
    },
    creditNoteWaitingPaidTotal: {
      value: "0.00",
    },
    reasonType: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    reasonDescription: {
      text: "",
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    returnStock: {
      value: { id: 1 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    reduceDebtType: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
      hidden: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.CreditNote, Enums.FinanceType.InFlow)
  );
  return model;
}
function GetModelReceivedDebitNote(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isHumanChange: false,
    isNotSuggestionPayment: false,
    headerName: "Receive_Debit_Note",
    transactionType: Enums.TransactionType.DebitNote,
    financeType: Enums.FinanceType.OutFlow,
    isValidateError: true,
    transactionDisabled: false,
    debitNoteAmount: 0,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    reasonType: {
      value: { id: 0 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    reasonDescription: {
      text: "",
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    returnStock: {
      value: { id: 1 },
      validateError: false,
      disabled: false,
      hidden: false,
      isNotAuto: false,
    },
    transactionReferenceAmount: {
      value: "0.00",
      isActive: false,
      disabled: false,
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(Enums.TransactionType.DebitNote, Enums.FinanceType.InFlow)
  );
  return model;
}
function GetModelReceiveDeposit(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Deposit_Payment",
    transactionType: Enums.TransactionType.Deposit,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.None,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: true,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(false, true),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Deposit,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.None
    )
  );
  return model;
}
function GetModelGoodsReceipt(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Goods_Receipt",
    transactionType: Enums.TransactionType.GoodsReceipt,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.None,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: true,
      hidden: true,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.GoodsReceipt,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.None
    )
  );
  return model;
}
function GetModelInvoiceReceipt(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Invoice_Receipt",
    transactionType: Enums.TransactionType.InvoiceReceipt,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.None,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Valid_Until",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    payment: paymentHelper.GetCreateTransactionPaymentDefualt(false),
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Invoice,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.PurchaseInventory
    )
  );
  return model;
}
function GetModelPurchaseRequisition(createOrEdit, allocationList) {
  let model = {
    id: 0,
    pageNo: 0,
    pageSize: 0,
    transactionIndex: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isHumanChange: false,
    headerName: "Purchase_Requisition",
    transactionType: Enums.TransactionType.PurchaseRequisition,
    isValidateError: true,
    financeType: Enums.FinanceType.OutFlow,
    expenseType: Enums.ExpenseType.None,
    quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.None,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Request_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: true,
      hidden: true,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: transactionHelper.GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: transactionHelper.GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [],
    transactionItemDisabled: false,
    tagList: [],
    fileList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList),
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(
    transactionHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.PurchaseRequisition,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.None
    )
  );
  return model;
}
function SetTransactionForDoPaidPayment(transaction, transactionDetail, transactionType, accountListForMap) {
  transaction.id = transactionDetail.id.ToNumber();
  transaction.number.value = transactionDetail.number;
  transaction.date.value = transactionDetail.date;
  transaction.financeType = transactionDetail.financeType;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.transactionType = transactionType;
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal;
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal;
  transaction.transactionSummary.vat.preVatTotalDefualt = transactionDetail.transactionSummary.preVatTotal;
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal;
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.vat.vatTotalBeforeEdit = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.remainPaymentNetAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount =
    transactionDetail.transactionSummary.remainWhtPaymentNetAmount;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount;
  transaction.transactionSummary.paymentWht.whtTotal = transactionDetail.transactionSummary.whtTotal;
  transaction.transactionSummary.paymentWht.paymentNetAmount =
    transaction.transactionSummary.netAmount.ToNumber() - transactionDetail.transactionSummary.whtTotal.ToNumber();
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;
  transaction.payment = paymentHelper.GetCreateTransactionPaymentDefualt(true);
  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionItemRaw of transactionDetail.transactionItemList) {
      const transactionItem = transactionHelper.GetCreateTransactionItemDefualt(
        transactionType,
        transactionDetail.financeType,
        transactionDetail.expenseType
      );
      const selectedAccount = accountListForMap.get(transactionItemRaw.accountId);
      if (selectedAccount) {
        transactionItem.account = selectedAccount;
      }
      transactionItem.amount.value = transactionItemRaw.quantity.ToPeakTransactionItemFormat();
      transactionItem.price.value = transactionItemRaw.toCurrencyPrice.ToPeakTransactionItemFormat();
      transactionItem.discount.value = transactionItemRaw.toCurrencyDiscount.ToPeakTransactionItemFormat();
      transactionItem.discount.discountTypeId = transactionItemRaw.discountType;
      transactionItem.vatTypeId.value = transactionItemRaw.vatType;
      transactionItem.itemWht.value = transactionItemRaw.toCurrencyWHTTotal;
      transactionItem.itemWht.whtAmountType = transactionItemRaw.whtAmountType;
      transaction.transactionItemList.push(transactionItem);
    }
  }
  if (transaction.payment && transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    let toDate = new Date();
    let transactionDate = new Date(transactionDetail.date);
    if (transactionDate < toDate) {
      transaction.payment.paymentGroupList[0].paymentGroupDate = toDate.ToDateJsonString();
    } else {
      transaction.payment.paymentGroupList[0].paymentGroupDate = transactionDate.ToDateJsonString();
    }
  }
}
function SetBillingNoteForDoPaidPayment(transaction, transactionDetail) {
  transaction.id = transactionDetail.id.ToNumber();
  transaction.number.value = transactionDetail.number;
  transaction.date.value = transactionDetail.date;
  transaction.financeType = transactionDetail.financeType;
  transaction.expenseType = transactionDetail.expenseType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.transactionType = Enums.TransactionType.BillingNote;
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal;
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal;
  transaction.transactionSummary.vat.preVatTotalDefualt = transactionDetail.transactionSummary.preVatTotal;
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal;
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.vat.vatTotalBeforeEdit = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.remainPaymentNetAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount =
    transactionDetail.transactionSummary.remainWhtPaymentNetAmount;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isNoneOrNotSpecifyWht;
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount;
  transaction.transactionSummary.paymentWht.whtTotal = transactionDetail.transactionSummary.whtTotal;
  transaction.transactionSummary.paymentWht.paymentNetAmount =
    transaction.transactionSummary.netAmount.ToNumber() - transactionDetail.transactionSummary.whtTotal.ToNumber();
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;
  transaction.payment = paymentHelper.GetCreateTransactionPaymentDefualt(true);
  if (transactionDetail.transactionItemList && transactionDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionItemRaw of transactionDetail.transactionItemList) {
      transaction.transactionItemList.push(transactionItemRaw);
    }
  }
  if (transaction.payment && transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    let toDate = new Date();
    let transactionDate = new Date(transactionDetail.date);
    if (transactionDate < toDate) {
      transaction.payment.paymentGroupList[0].paymentGroupDate = toDate.ToDateJsonString();
    } else {
      transaction.payment.paymentGroupList[0].paymentGroupDate = transactionDate.ToDateJsonString();
    }
  }
}
function SetBookmarkForTransaction(transaction, transactionDetail) {
  transaction.id = transactionDetail.transactionTemplateId.ToNumber();
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transactionDetail.expenseType
      );
      transaction.transactionItemList.push(transactionItem);
    }
  }

  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt = transactionDetail.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt = transactionDetail.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal = transactionDetail.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt = transactionDetail.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal = transactionDetail.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit = transactionDetail.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.sameProductVatTypeId;
}
function GetTransactionForEasyEditAllocation(transactionDetail, allocationList) {
  let transaction = {
    id: transactionDetail.id,
    number: transactionDetail.number,
    transactionType: transactionDetail.transactionType,
    financeType: transactionDetail.financeType,
    expenseType: transactionDetail.expenseType,
    transactionItemType: transactionDetail.transactionItemType,
    reference: {
      referenceTypeId: transactionDetail.referenceType,
    },
    allocationTransactionList: transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transactionDetail.financeType
    ),
    transactionItemList: [],
  };

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      transactionItem.id = transactionDetailItem.id;

      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }

      transaction.transactionItemList.push(transactionItem);
    }
  }

  return transaction;
}

function FilterAllocationByFinanceType(financeType, allocationList) {
  let _allocationList = [];

  if (allocationList && allocationList.length > 0) {
    if (financeType === Enums.FinanceType.InFlow) {
      _allocationList = allocationList.filter(
        (x) =>
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Income ||
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
      );
    } else if (financeType === Enums.FinanceType.OutFlow) {
      _allocationList = allocationList.filter(
        (x) =>
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Expense ||
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
      );
    } else {
      _allocationList = allocationList.filter(
        (x) =>
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Income ||
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Expense ||
          x.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
      );
    }
  }

  return _allocationList;
}
export const IsPercentage = (value) => {
  if (value) {
    return String(value).slice(-1) === "%";
  } else {
    return false;
  }
};

export const SetStatementToCreateTransaction = (
  transaction,
  statementPaymentDate,
  statementBankAccountId,
  paymentAmount = 0
) => {
  transaction.payment.isDisabledByStatement = true;
  transaction.date.value = statementPaymentDate;
  if (transaction.payment.paymentGroupList && transaction.payment.paymentGroupList.length > 0) {
    const paymentGroup = transaction.payment.paymentGroupList[0];
    paymentGroup.isPaymentActive = true;
    paymentGroup.paymentGroupDate = statementPaymentDate;
    if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
      const paymentTransactionBankAccount = paymentGroup.paymentTransactionBankAccountList[0];
      paymentTransactionBankAccount.bankAccountId = statementBankAccountId;
      paymentTransactionBankAccount.paymentAmount = paymentAmount.FormatMoney();
      paymentTransactionBankAccount.disableBankAccount = true;
    }
  }
};

export const SetSuggestContactFromStatement = async (contact, statementRemark, statementBankReferenceBankId) => {
  let suggestedContact = await SetContactStatementRemarkFrequencyToSuggestContact(
    statementRemark,
    statementBankReferenceBankId
  );
  if (!suggestedContact) {
    suggestedContact = await SetStatementToSuggestContact(statementRemark, statementBankReferenceBankId);
  }
  if (suggestedContact) {
    contact = importHelper.SelectedContact(contact, suggestedContact);
  }
};

export const SetContactStatementRemarkFrequencyToSuggestContact = async (
  statementRemark,
  statementBankReferenceBankId
) => {
  let suggestedContact = null;
  const contactStatementRemarkFrequencyMapCache = await store.dispatch(
    "DoGetContactStatementRemarkFrequency",
    statementBankReferenceBankId
  );

  if (contactStatementRemarkFrequencyMapCache) {
    const contactStatementRemarkFrequency = contactStatementRemarkFrequencyMapCache.get(statementRemark);
    if (contactStatementRemarkFrequency) {
      const contactId = contactStatementRemarkFrequency.contactId;
      const contactModelList = await store.dispatch("DoGetContactByContactIdList", [contactId]);
      if (contactModelList && contactModelList.length > 0) {
        suggestedContact = contactModelList.find((x) => x.id == contactId);
      }
    }
  }

  return suggestedContact;
};

export const SetStatementToSuggestContact = async (statementRemark, bankReferenceBankId) => {
  const extractedRemark = ExtractBankDetailsFromRemark(statementRemark, bankReferenceBankId);

  const searchText = extractedRemark.bankaccountname ? extractedRemark.bankaccountname.split(" ")[0] : "";

  const contactSearch = await store.dispatch("DoGetContactSearchWithSearchTextPromise", {
    searchText: searchText,
    sequenceNumber: 0,
    contactFinanceType: Enums.ContactFinanceType.All,
  });
  const getContactList = [...contactSearch];
  const contactIdList = getContactList.map((contact) => contact.id);
  const contactListWithBankDetail = await store.dispatch("DoGetContactByContactIdList", contactIdList);
  const filteredContacts = contactListWithBankDetail.filter((contact) => contactIdList.includes(contact.id));
  return SuggestContactByRemark(filteredContacts, extractedRemark);
};

export const ValidatePaymentByStatement = (bankAccountId, paymentAmount, transactionCreate) => {
  if (
    transactionCreate.payment.paymentGroupList[0] &&
    transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList.length > 0
  ) {
    if (
      transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId ==
        bankAccountId &&
      transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].paymentAmount.ToNumber() ==
        paymentAmount
    ) {
      return true;
    }
  }
  return false;
};

export const GetPaymentTransactionIdForReconcileFromPaymentGroupList = (
  paymentGroupList,
  bankAccountId,
  paymentAmount
) => {
  let paymentTransactionIdForReconcile = 0;
  const paymentTransactionIdOtherList = [];
  if (paymentGroupList && paymentGroupList.length > 0) {
    const paymentAmountNumber = paymentAmount.ToNumber() < 0 ? paymentAmount.ToNumber() * -1 : paymentAmount.ToNumber();
    for (const paymentGroup of paymentGroupList) {
      if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
        for (const paymentTransactionBankAccount of paymentGroup.paymentTransactionBankAccountList) {
          if (
            paymentTransactionIdForReconcile == 0 &&
            paymentTransactionBankAccount.bankAccountId == bankAccountId &&
            paymentTransactionBankAccount.paymentAmount.ToNumber() == paymentAmountNumber
          ) {
            paymentTransactionIdForReconcile = paymentTransactionBankAccount.id;
          } else if (paymentTransactionBankAccount.bankAccountId == bankAccountId) {
            paymentTransactionIdOtherList.push(paymentTransactionBankAccount.id);
          }
        }
      }
    }
  }
  return { paymentTransactionIdForReconcile, paymentTransactionIdOtherList };
};

export const GetPaymentTransactionIdForReconcileFromPaymentGroupDetail = (paymentGroupDetailList, bankAccountId) => {
  let paymentTransactionIdListForReconcile = [];
  if (paymentGroupDetailList && paymentGroupDetailList.length > 0) {
    for (const paymentGroupDetail of paymentGroupDetailList) {
      if (paymentGroupDetail.paymentTransactionList && paymentGroupDetail.paymentTransactionList.length > 0) {
        for (const paymentTransaction of paymentGroupDetail.paymentTransactionList) {
          if (paymentTransaction.bankaccountId == bankAccountId) {
            paymentTransactionIdListForReconcile.push(paymentTransaction.id);
          }
        }
      }
    }
  }

  return paymentTransactionIdListForReconcile;
};

export function GetPartialQuotationOptionsFromURLQuery(query) {
  const quotationReferenceTransactionTypeFromQuery = query.cpqt
    ? query.cpqt.ToNumber()
    : Enums.QuotationReferenceTransactionType.None;

  switch (quotationReferenceTransactionTypeFromQuery) {
    case Enums.QuotationReferenceTransactionType.None:
      return {
        percent: -1,
        quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.Default,
      };
    case Enums.QuotationReferenceTransactionType.Percent:
      return {
        percent: query.percent ? query.percent.ToNumber() : -1,
        quotationReferenceTransactionType: Enums.QuotationReferenceTransactionType.Percent,
      };
    default:
      return {
        percent: -1,
        quotationReferenceTransactionType: quotationReferenceTransactionTypeFromQuery,
      };
  }
}

export function SetCreatePartialQuotation(
  transaction,
  quotationDetail,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  transaction.quotationReferenceTransactionType =
    quotationDetail.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.None
      ? quotationReferenceTransactionType
      : quotationDetail.quotationReferenceTransactionType;

  transaction.contact.disabled = true;

  if (transaction.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.Percent) {
    if (percent.ToAccountingRoundUp().ToNumber() >= 0) {
      transaction.quotationReferenceTransactionPercent = percent.ToAccountingRoundUp().ToNumber();
    } else {
      transaction.quotationReferenceTransactionPercent = peakUtility
        .PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(
            quotationDetail.quotationReferenceTransactionRemainingToCurrencyNetTotal,
            quotationDetail.transactionCurrency.currencyNetAmount
          ),
          100
        )
        .ToAccountingRoundUp()
        .ToNumber();
    }
  } else {
    transaction.quotationReferenceTransactionPercent = 0;
  }

  transaction.settingQuotationPartial =
    settingQuotationPartial && settingQuotationPartial.isActive ? settingQuotationPartial : null;

  if (
    transaction.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.TransactionItem ||
    transaction.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.Percent
  ) {
    transaction.taxStatus.disabled = true;
    transaction.transactionCurrencySummary.disableCurrency = true;
  }

  if (transaction.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.Percent) {
    if (transaction.transactionDiscount.discountType === Enums.DiscountType.Currency) {
      const decimalPercent = peakUtility.PeakOperatorDivide(
        transaction.quotationReferenceTransactionPercent.ToNumber(),
        100
      );

      transaction.transactionDiscount.value = peakUtility
        .PeakOperatorMultiply(transaction.transactionDiscount.value, decimalPercent)
        .ToPeakTransactionItemFormat();
    }
  }
}

export function SetCreatePartialQuotationItem(
  transactionItem,
  _quotationItem,
  transactionCreate,
  settingQuotationPartial,
  documentType = Enums.DocumentType.Create
) {
  transactionItem.referenceQuotationItemId = _quotationItem.id;
  transactionItem.referenceAmount = _quotationItem.amount.ToPeakTransactionItemFormat();
  transactionItem.referencePrice = _quotationItem.price.ToPeakTransactionItemFormat();
  transactionItem.referenceDiscount = _quotationItem.discount.ToPeakTransactionItemFormat();

  if (
    transactionCreate.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.TransactionItem ||
    transactionCreate.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.Percent
  ) {
    transactionItem.checked.value = true;
    transactionItem.checked.hidden = false;

    transactionItem.productTemplate.disabled = true;
    transactionItem.fixedAssetTemplate.disabled = true;
    transactionItem.fixedAsset.disabled = true;
    transactionItem.account.disabled = true;
  }

  if (transactionCreate.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.TransactionItem) {
    if (settingQuotationPartial && settingQuotationPartial.isActive) {
      transactionItem.amount.disabled =
        settingQuotationPartial.editAmountType === Enums.SettingPartialQuotationEditType.None;
      transactionItem.price.disabled =
        settingQuotationPartial.editPriceType === Enums.SettingPartialQuotationEditType.None;
      transactionItem.discount.disabled =
        settingQuotationPartial.editDiscountType === Enums.SettingPartialQuotationEditType.None;
    }

    if (transactionItem.amount.value.ToNumber() === 0) {
      transactionItem.checked.value = false;
      transactionItem.hidden = true;
    }
  }

  if (transactionCreate.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.Percent) {
    transactionItem.amount.disabled = true;

    if (documentType === Enums.DocumentType.Create) {
      const { price, discount } = GetCalculatedPartialQuotationItemTypePercent(
        transactionItem.price.value,
        transactionItem.discount.value,
        transactionItem.discount.discountTypeId,
        transactionCreate.quotationReferenceTransactionPercent
      );

      transactionItem.price.value = price;
      transactionItem.discount.value = discount;
    }
  }
}

export function GetCalculatedPartialQuotationItemTypePercent(price, discount, discountType, percent) {
  const decimalPercent = peakUtility.PeakOperatorDivide(percent.ToNumber(), 100);

  let calculatedPrice = price;
  let calculatedDiscount = discount;

  calculatedPrice = peakUtility.PeakOperatorMultiply(price, decimalPercent);

  if (discountType === Enums.DiscountType.Currency) {
    calculatedDiscount = peakUtility.PeakOperatorMultiply(discount, decimalPercent);
  }

  return {
    price: calculatedPrice.ToPeakTransactionItemFormat(),
    discount: calculatedDiscount.ToPeakTransactionItemFormat(),
  };
}

export function SetQuotationForCreateTransactionBase(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  transaction.reference.referenceId = quotationDetail.id;
  transaction.reference.referenceTypeId = Enums.TransactionType.Quotation;
  transaction.reference.referenceName = quotationDetail.number;
  transaction.reference.referenceNumber = quotationDetail.number;
  transaction.reference.referenceIssueDate = new Date(quotationDetail.date).ToDateJsonString();
  transaction.transactionDiscount.value = quotationDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = quotationDetail.discountType;
  transaction.contact.id = quotationDetail.contact.id;
  transaction.contact.disabled = true;
  transaction.contact.contactCode = quotationDetail.contact.contactCode;
  transaction.isValidateError = false;
  transaction.taxStatus.value = quotationDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = quotationDetail.remark;
  transaction.transactionItemType = quotationDetail.transactionItemType;

  SetCreatePartialQuotation(
    transaction,
    quotationDetail,
    quotationReferenceTransactionType,
    percent,
    settingQuotationPartial
  );

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      quotationDetail.allocationTransactionList,
      allocationList,
      transaction.financeType
    );
  }

  const transactionPaymentRatio =
    transaction.reference.paymentGroupId > 0
      ? peakUtility.PeakOperatorDivide(
          transaction.payment.paymentAllGroupTotal,
          quotationDetail.transactionSummary.netAmount
        )
      : 1;

  if (quotationDetail.transactionItemList && quotationDetail.transactionItemList.length > 0) {
    transaction.transactionItemList = [];

    for (const _quotationItem of quotationDetail.transactionItemList) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        _quotationItem,
        transaction.transactionType,
        transaction.financeType,
        true,
        transaction.expenseType,
        transaction.transactionItemType
      );

      SetCreatePartialQuotationItem(
        transactionItem,
        _quotationItem,
        transaction,
        settingQuotationPartial,
        Enums.DocumentType.Create
      );

      transactionItem.allocationTransactionList = [];

      if (!CheckPackageCanUseAllocation() && transaction.transactionType !== Enums.TransactionType.Deposit) {
        transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
          _quotationItem.allocationTransactionList,
          allocationList,
          transaction.financeType
        );

        if (transactionItem.allocationTransactionList.length > 0) {
          transactionItem.isUseTransactionAllocation = _quotationItem.isUseTransactionAllocation;
        }
      }

      if (transactionItem.itemWht.value != null) {
        transactionItem.itemWht.value = peakUtility.PeakOperatorMultiply(
          transactionItem.itemWht.value,
          transactionPaymentRatio
        );
      }

      if (transactionItem.hidden === false) {
        transaction.transactionItemList.push(transactionItem);
      }
    }

    if (transaction.transactionItemList.length === 0) {
      const newTransactionItem = transactionItemHelper.GetCreateTransactionItemDefualt(
        transaction.transactionType,
        transaction.financeType,
        transaction.expenseType,
        transaction.transactionItemType
      );

      transaction.transactionItemList.push(newTransactionItem);
    }

    if (transaction.quotationReferenceTransactionType === Enums.QuotationReferenceTransactionType.Percent) {
      transaction.transactionItemList.push(GetPartialQuotationItemDescriptionTypePercent(transaction, quotationDetail));
    }
  }

  transaction.transactionCurrencySummary.isGetSuggestionCurrency = true;
  transaction.transactionCurrencySummary.toCurrencyUId = quotationDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    quotationDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = quotationDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt = quotationDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = quotationDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    quotationDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    quotationDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = quotationDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = quotationDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    quotationDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    quotationDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    quotationDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = quotationDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = quotationDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = quotationDetail.transactionSummary.sameProductVatType;

  transactionHelper.CalculatePreVatTotalFromEditVatTransaction(transaction);
  transactionHelper.SetTransactionSummary(transaction);
}

export function SetQuotationForCreateInvoice(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  SetQuotationForCreateTransactionBase(
    transaction,
    quotationDetail,
    allocationList,
    quotationReferenceTransactionType,
    percent,
    settingQuotationPartial
  );
}

export function SetQuotationForCreateDeposit(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  SetQuotationForCreateTransactionBase(
    transaction,
    quotationDetail,
    allocationList,
    quotationReferenceTransactionType,
    percent,
    settingQuotationPartial
  );
}

export function SetQuotationForCreateReceipt(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  SetQuotationForCreateTransactionBase(
    transaction,
    quotationDetail,
    allocationList,
    quotationReferenceTransactionType,
    percent,
    settingQuotationPartial
  );
}

export function SetQuotationForCreateGoodsReceipt(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  SetQuotationForCreateTransactionBase(
    transaction,
    quotationDetail,
    allocationList,
    quotationReferenceTransactionType,
    percent,
    settingQuotationPartial
  );

  const goodsReceiptDate = new Date(transaction.date.value);
  const purchaseOrderDate = new Date(quotationDetail.date);

  if (purchaseOrderDate > goodsReceiptDate) {
    transaction.date.value = purchaseOrderDate.ToDateJsonString();
  }
}

export function SetQuotationForCreateInvoiceReceipt(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  SetQuotationForCreateTransactionBase(
    transaction,
    quotationDetail,
    allocationList,
    quotationReferenceTransactionType,
    percent,
    settingQuotationPartial
  );

  const invoiceReceiptDate = new Date(transaction.date.value);
  const purchaseOrderDate = new Date(quotationDetail.date);

  if (purchaseOrderDate > invoiceReceiptDate) {
    transaction.date.value = purchaseOrderDate.ToDateJsonString();
  }
}

export function SetQuotationForCreateTransaction(
  transaction,
  quotationDetail,
  allocationList,
  quotationReferenceTransactionType,
  percent,
  settingQuotationPartial
) {
  switch (transaction.transactionType) {
    case Enums.TransactionType.Invoice:
      SetQuotationForCreateInvoice(
        transaction,
        quotationDetail,
        allocationList,
        quotationReferenceTransactionType,
        percent,
        settingQuotationPartial
      );
      break;
    case Enums.TransactionType.Deposit:
      SetQuotationForCreateDeposit(
        transaction,
        quotationDetail,
        allocationList,
        quotationReferenceTransactionType,
        percent,
        settingQuotationPartial
      );
      break;
    case Enums.TransactionType.Receipt:
      SetQuotationForCreateReceipt(
        transaction,
        quotationDetail,
        allocationList,
        quotationReferenceTransactionType,
        percent,
        settingQuotationPartial
      );
      break;
    case Enums.TransactionType.GoodsReceipt:
      SetQuotationForCreateGoodsReceipt(
        transaction,
        quotationDetail,
        allocationList,
        quotationReferenceTransactionType,
        percent,
        settingQuotationPartial
      );
      break;
    case Enums.TransactionType.InvoiceReceipt:
      SetQuotationForCreateInvoiceReceipt(
        transaction,
        quotationDetail,
        allocationList,
        quotationReferenceTransactionType,
        percent,
        settingQuotationPartial
      );
      break;
  }
}

export function CombineReferenceQuotationItemsToTransactionEdit(
  transaction,
  transactionDetail,
  allocationList,
  quotationForCreateTransaction
) {
  const quotationItemForCreateTransactionMapper = new Map(); /* id -> index  */

  for (const [index, _quotationItem] of quotationForCreateTransaction.transactionItems.entries()) {
    let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
      _quotationItem,
      transaction.transactionType,
      transaction.financeType,
      true,
      transaction.expenseType,
      transaction.transactionItemType
    );

    SetCreatePartialQuotationItem(
      transactionItem,
      _quotationItem,
      transaction,
      transaction.settingQuotationPartial,
      Enums.DocumentType.Edit
    );

    quotationItemForCreateTransactionMapper.set(_quotationItem.id, index);

    transactionItem.checked.value = false;
    transactionItem.checked.hidden = false;

    DisablePartialQuotationItem(transactionItem);

    if (!CheckPackageCanUseAllocation()) {
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        _quotationItem.allocationList,
        allocationList,
        transaction.financeType
      );
    }

    if (transactionItem.allocationTransactionList.length > 0) {
      transactionItem.isUseTransactionAllocation = _quotationItem.isUseTransactionAllocation;
    }

    transaction.transactionItemList.push(transactionItem);
  }

  for (const transactionDetailItem of transactionDetail.transactionItems) {
    let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
      transactionDetailItem,
      transaction.transactionType,
      transaction.financeType,
      true,
      transaction.expenseType,
      transaction.transactionItemType
    );

    if (!CheckPackageCanUseAllocation()) {
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );
    }

    if (transactionItem.allocationTransactionList.length > 0) {
      transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
    }

    if (transactionDetailItem.referenceQuotationItemId > 0) {
      const index = quotationItemForCreateTransactionMapper.get(transactionDetailItem.referenceQuotationItemId);

      if (index !== undefined) {
        SetCreatePartialQuotationItem(
          transactionItem,
          quotationForCreateTransaction.transactionItems[index],
          transaction,
          transaction.settingQuotationPartial,
          Enums.DocumentType.Edit
        );

        transaction.transactionItemList[index] = transactionItem;
      }
    } else {
      transaction.transactionItemList.push(transactionItem);
    }
  }
}
export const ValidatePaymentPaymentAmountEmpty = (transactionCreate) => {
  let isHaveTransactionBankAccount = false;
  let isHaveTransactionChartAccount = false;
  let isHaveTransactionDocument = false;

  if (transactionCreate.payment.paymentGroupList[0]) {
    if (transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList.length > 0) {
      for (const paymentTransactionBankAccount of transactionCreate.payment.paymentGroupList[0]
        .paymentTransactionBankAccountList) {
        if (paymentTransactionBankAccount.paymentAmount.ToNumber() > 0) {
          isHaveTransactionBankAccount = true;
        }
        if (isHaveTransactionBankAccount) {
          break;
        }
      }
    }

    if (transactionCreate.payment.paymentGroupList[0].paymentTransactionChartOfAccountList.length > 0) {
      for (const paymentTransactionChartOfAccount of transactionCreate.payment.paymentGroupList[0]
        .paymentTransactionChartOfAccountList) {
        if (paymentTransactionChartOfAccount.paymentAmount.ToNumber() > 0) {
          isHaveTransactionChartAccount = true;
        }
        if (isHaveTransactionChartAccount) {
          break;
        }
      }
    }

    if (transactionCreate.payment.paymentGroupList[0].paymentTransactionDocumentList.length > 0) {
      for (const paymentTransactionDocument of transactionCreate.payment.paymentGroupList[0]
        .paymentTransactionDocumentList) {
        if (paymentTransactionDocument.paymentAmount.ToNumber() > 0) {
          isHaveTransactionDocument = true;
        }
        if (isHaveTransactionDocument) {
          break;
        }
      }
    }
  }
  return isHaveTransactionBankAccount || isHaveTransactionChartAccount || isHaveTransactionDocument;
};

export const SetPurchaseRequisitionForCreateTransaction = (transaction, transactionDetail, allocationList) => {
  transaction.reference.referenceId = transactionDetail.id;
  transaction.reference.referenceTypeId = Enums.TransactionType.PurchaseRequisition;
  transaction.reference.referenceName = transactionDetail.number;
  transaction.reference.referenceNumber = transactionDetail.number;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.disabled = transactionDetail.contactId > 0;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  if (!CheckPackageCanUseAllocation()) {
    transaction.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
      transactionDetail.allocationList,
      allocationList,
      transaction.financeType
    );
  }

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionDetailItem of transactionDetail.transactionItems) {
      let transactionItem = transactionHelper.GetCreateTransactionItemFromTransactionItem(
        transactionDetailItem,
        transaction.transactionType,
        transaction.financeType,
        true
      );
      transactionItem.allocationTransactionList = transactionHelper.SetEditAllocationTransaction(
        transactionDetailItem.allocationList,
        allocationList,
        transaction.financeType
      );

      if (transactionItem.allocationTransactionList.length > 0) {
        transactionItem.isUseTransactionAllocation = transactionDetailItem.isUseTransactionAllocation;
      }
      transaction.transactionItemList.push(transactionItem);
    }
  }
  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.isGetSuggestionCurrency = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
};

export const GetPartialQuotationItemDescriptionTypePercent = (transactionCreate, quotationDetail) => {
  let transactionItem = transactionItemHelper.GetCreateTransactionItemDefualt(
    transactionCreate.transactionType,
    transactionCreate.financeType,
    transactionCreate.expenseType,
    transactionCreate.transactionItemType
  );

  const documentType = GetTransactionName(
    transactionCreate.transactionType,
    transactionCreate.financeType,
    transactionCreate.transactionItemType,
    transactionCreate.expenseType
  );
  const percent = transactionCreate.quotationReferenceTransactionPercent.ToAccountingRoundUp();
  const amount = peakUtility
    .PeakOperatorMultiply(
      quotationDetail.transactionCurrency.currencyNetAmount,
      peakUtility.PeakOperatorDivide(transactionCreate.quotationReferenceTransactionPercent, 100)
    )
    .FormatMoney();
  const quotationAmount = quotationDetail.transactionCurrency.currencyNetAmount.FormatMoney();
  const currency =
    quotationDetail.transactionCurrency.toCurrencyUid === Enums.CurrencyCode.THB
      ? i18n.t("Baht")
      : transactionItemHelper.GetCurrencyCodeByUid(quotationDetail.transactionCurrency.toCurrencyUid).currencyCode;

  transactionItem.isDescriptionOnly = true;
  transactionItem.description.text = i18n.t("Create_Partial_Quotation_Type_Percent_Description", {
    documentType,
    percent,
    amount,
    quotationAmount,
    currency,
  });

  return transactionItem;
};

const GetDisableContactByReference = (transactionDetail) => {
  if (
    transactionDetail &&
    transactionDetail.referenceId > 0 &&
    transactionDetail.referenceType > 0 &&
    transactionDetail.referenceContactId > 0
  ) {
    return true;
  }
  return false;
};

export const GetAccountForRecommendFromAmount = (
  frequentlyUsedAccountList,
  aiRecommendedAccount,
  allAccountListMap
) => {
  let selectAccount = null;

  if (frequentlyUsedAccountList && frequentlyUsedAccountList.length > 0) {
    selectAccount = allAccountListMap.get(frequentlyUsedAccountList[0]);
  } else {
    if (aiRecommendedAccount && aiRecommendedAccount.length > 0) {
      selectAccount = allAccountListMap.get(aiRecommendedAccount[0].accountId);
    }
  }

  return selectAccount;
};

export const GetPricePerUnitFromStatementAmount = (taxStatus, vatType, statementAmount) => {
  let pricePerUnit = 0;

  const percentVat = vatType === Enums.ProductVatType.SevenPercent ? 7 : 0;
  if (taxStatus === Enums.TaxStatus.ExcludeTax) {
    pricePerUnit = (100 / (100 + percentVat)) * statementAmount;
  } else if (taxStatus === Enums.TaxStatus.IncludeTax) {
    pricePerUnit = (100 / (100 + percentVat)) * statementAmount * ((100 + percentVat) / 100);
  }

  return pricePerUnit;
};

export const SetRecommendFromAmount = (transaction, taxStatus, contactId, selectAccount, pricePerUnit) => {
  transaction.taxStatus.value = taxStatus;
  transaction.contact.id = contactId;
  transaction.transactionDiscount.value = "0.00";
  transaction.transactionDiscount.discountType = 0;
  transaction.transactionSummary = transactionHelper.GetCreateTransactionSummaryDefualt();
  transaction.transactionCurrencySummary = transactionHelper.GetCreateTransactionCurrencySummaryDefualt();
  transaction.referenceDepositList = [];
  transaction.referenceDepositSummary = GetCreateReferenceDepositSummaryDefualt();
  transaction.payment = paymentHelper.GetCreateTransactionPaymentDefualt();
  transaction.transactionItemList = [];
  transaction.transactionItemList.push(
    transactionItemHelper.GetCreateTransactionItemDefualt(
      Enums.TransactionType.Invoice,
      Enums.FinanceType.OutFlow,
      Enums.ExpenseType.Expense
    )
  );
  transaction.transactionItemList[0] = importHelper.SelectedAccount(
    transaction.transactionItemList[0],
    selectAccount,
    Enums.TransactionType.Invoice,
    Enums.FinanceType.OutFlow
  );
  transaction.transactionItemList[0].price.value = pricePerUnit.ToPeakTransactionItemFormat();
};

export default {
  GetTrasactionTypeModel(transactionType, financeType, expenseType) {
    return {
      transactionType: transactionType,
      financeType: financeType,
      expenseType: expenseType,
    };
  },
  CreateModel(
    createOrEdit,
    transactionType,
    financeType,
    expenseType,
    allocationList = [],
    transactionItemType = Enums.TransactionItemType.None
  ) {
    switch (transactionType) {
      case Enums.TransactionType.Quotation:
        if (financeType == Enums.FinanceType.InFlow) {
          return GetModelQuotation(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList)
          );
        } else {
          if (transactionItemType == Enums.TransactionItemType.Asset) {
            return GetModelPurchaseOrderAsset(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
            );
          } else {
            return GetModelPurchaseOrder(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
            );
          }
        }
      case Enums.TransactionType.Invoice:
        if (financeType == Enums.FinanceType.InFlow) {
          if (expenseType == Enums.ExpenseType.PurchaseAsset) {
            return GetModelSellAssetInvoice(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList)
            );
          } else {
            return GetModelInvoice(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList)
            );
          }
        } else {
          if (expenseType == Enums.ExpenseType.PurchaseInventory) {
            return GetModelPurchaseInventory(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
            );
          } else if (expenseType == Enums.ExpenseType.PurchaseAsset) {
            return GetModelPurchaseAsset(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
            );
          } else {
            return GetModelExpense(
              createOrEdit,
              FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
            );
          }
        }
      case Enums.TransactionType.Receipt:
        if (transactionItemType == Enums.TransactionItemType.Asset) {
          return GetModelSellAssetReceipt(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList)
          );
        } else {
          return GetModelReceipt(createOrEdit, FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList));
        }
      case Enums.TransactionType.TaxInvoice:
        return GetModelTaxInvoiceDefualt(createOrEdit);
      case Enums.TransactionType.CreditNote:
        if (financeType == Enums.FinanceType.InFlow) {
          return GetModelCreditNote(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList)
          );
        } else {
          return GetModelReceivedCreditNote(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
          );
        }
        break;
      case Enums.TransactionType.DebitNote:
        if (financeType == Enums.FinanceType.InFlow) {
          return GetModelDebitNote(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList)
          );
        } else {
          return GetModelReceivedDebitNote(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
          );
        }
        break;
      case Enums.TransactionType.BillingNote:
        if (financeType == Enums.FinanceType.InFlow) {
          return GetModelBillingNote(createOrEdit, financeType);
        } else {
          return GetModelBillingNote(createOrEdit, financeType);
        }
        break;
      case Enums.TransactionType.Deposit:
        if (financeType == Enums.FinanceType.InFlow) {
          return GetModelDeposit(createOrEdit, FilterAllocationByFinanceType(Enums.FinanceType.InFlow, allocationList));
        } else {
          return GetModelReceiveDeposit(
            createOrEdit,
            FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
          );
        }
        break;
      case Enums.TransactionType.GoodsReceipt:
        return GetModelGoodsReceipt(
          createOrEdit,
          FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
        );
        break;
      case Enums.TransactionType.InvoiceReceipt:
        return GetModelInvoiceReceipt(
          createOrEdit,
          FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
        );
        break;
      case Enums.TransactionType.PurchaseRequisition:
        return GetModelPurchaseRequisition(
          createOrEdit,
          FilterAllocationByFinanceType(Enums.FinanceType.OutFlow, allocationList)
        );
        break;
    }
  },
  SetMovementStockInputForTransaction(stockMovementInput) {
    let input = {
      pageNo: stockMovementInput.pageNo,
      pageSize: stockMovementInput.pageSize,
      productId: stockMovementInput.productTemplateId,
      searchText: stockMovementInput.searchText,
      isUseMainDatabase: stockMovementInput.isUseMainDatabase,
    };
    return input;
  },
  SetCreateTaxInvoiceModel(transaction, transactionDetail) {
    SetCreateTaxInvoiceModel(transaction, transactionDetail);
  },
  SetEditQuotationModel(transaction, transactionDetail, allocationList) {
    SetEditQuotationModel(transaction, transactionDetail, allocationList);
  },
  SetEasyEditModel(transaction, transactionDetail) {
    SetEasyEditModel(transaction, transactionDetail);
  },
  SetCopyPurchaseRequisitionModel(transaction, transactionDetail, allocationList) {
    SetCopyPurchaseRequisitionModel(transaction, transactionDetail, allocationList);
  },
  SetCopyQuotationModel(transaction, transactionDetail, allocationList) {
    SetCopyQuotationModel(transaction, transactionDetail, allocationList);
  },
  SetCopyQuotationToPurchaseOrderModel(transaction, transactionDetail, allocationList) {
    SetCopyQuotationToPurchaseOrderModel(transaction, transactionDetail, allocationList);
  },
  SetCopyDepositModel(transaction, transactionDetail, allocationList) {
    SetCopyDepositModel(transaction, transactionDetail, allocationList);
  },
  SetCopyGoodsReceiptModel(transaction, transactionDetail, allocationList) {
    SetCopyGoodsReceiptModel(transaction, transactionDetail, allocationList);
  },
  SetCopyInvoiceReceiptModel(transaction, transactionDetail, allocationList) {
    SetCopyInvoiceReceiptModel(transaction, transactionDetail, allocationList);
  },
  SetCopyExpenseRecordToQuotation(transaction, transactionDetail, allocationList) {
    SetCopyExpenseRecordToIncome(transaction, transactionDetail, allocationList);
  },
  SetEditDepositModel(
    transaction,
    transactionDetail,
    allocationList,
    quotationForCreateTransaction,
    settingQuotationPartial
  ) {
    SetEditDepositModel(
      transaction,
      transactionDetail,
      allocationList,
      quotationForCreateTransaction,
      settingQuotationPartial
    );
  },
  SetEditPurchaseRequisitionModel(transaction, transactionDetail, allocationList) {
    SetEditPurchaseRequisitionModel(transaction, transactionDetail, allocationList);
  },
  SetEditGoodsReceiptModel(
    transaction,
    transactionDetail,
    allocationList,
    quotationForCreateTransaction,
    settingQuotationPartial
  ) {
    SetEditGoodsReceiptModel(
      transaction,
      transactionDetail,
      allocationList,
      quotationForCreateTransaction,
      settingQuotationPartial
    );
  },
  SetEditInvoiceReceiptModel(
    transaction,
    transactionDetail,
    allocationList,
    quotationForCreateTransaction,
    settingQuotationPartial
  ) {
    SetEditInvoiceReceiptModel(
      transaction,
      transactionDetail,
      allocationList,
      quotationForCreateTransaction,
      settingQuotationPartial
    );
  },
  SetEditInvoiceModel(
    transaction,
    transactionDetail,
    allocationList,
    quotationForCreateTransaction,
    settingQuotationPartial
  ) {
    SetEditInvoiceModel(
      transaction,
      transactionDetail,
      allocationList,
      quotationForCreateTransaction,
      settingQuotationPartial
    );
  },
  SetEditCreditNoteModel(transaction, transactionDetail, allocationList) {
    SetEditCreditNoteModel(transaction, transactionDetail, allocationList);
  },
  SetEditDebitNoteModel(transaction, transactionDetail, allocationList) {
    SetEditDebitNoteModel(transaction, transactionDetail, allocationList);
  },
  SetDetailRecurringInvoiceModel(transaction, transactionDetail, allocationList) {
    SetDetailRecurringInvoiceModel(transaction, transactionDetail, allocationList);
  },
  SetCopyInvoiceModel(transaction, transactionDetail, allocationList) {
    SetCopyInvoiceModel(transaction, transactionDetail, allocationList);
  },
  SetCopyExpenseRecordToInvoiceModel(transaction, transactionDetail, allocationList) {
    SetCopyExpenseRecordToIncome(transaction, transactionDetail, allocationList);
  },
  SetCopyExpenseRecordToReceiptModel(transaction, transactionDetail, allocationList) {
    SetCopyExpenseRecordToIncome(transaction, transactionDetail, allocationList);
  },
  SetCopyRecurringInvoiceModel(transaction, transactionDetail, allocationList) {
    SetCopyRecurringInvoiceModel(transaction, transactionDetail, allocationList);
  },
  SetCopyCreditNoteModel(transaction, transactionDetail, allocationList) {
    SetCopyCreditNoteModel(transaction, transactionDetail, allocationList);
  },
  SetCopyDebitNoteModel(transaction, transactionDetail, allocationList) {
    SetCopyDebitNoteModel(transaction, transactionDetail, allocationList);
  },
  SetEditReceiptModel(
    transaction,
    transactionDetail,
    allocationList,
    quotationForCreateTransaction,
    settingQuotationPartial
  ) {
    SetEditReceiptModel(
      transaction,
      transactionDetail,
      allocationList,
      quotationForCreateTransaction,
      settingQuotationPartial
    );
  },
  SetDetailRecurringReceiptModel(transaction, transactionDetail, allocationList) {
    SetDetailRecurringReceiptModel(transaction, transactionDetail, allocationList);
  },
  SetCopyReceiptModel(transaction, transactionDetail, allocationList) {
    SetCopyReceiptModel(transaction, transactionDetail, allocationList);
  },
  SetCopyRecurringReceiptModel(transaction, transactionDetail, allocationList) {
    SetCopyRecurringReceiptModel(transaction, transactionDetail, allocationList);
  },
  SetEditTaxInvoiceModel(transaction, transactionDetail) {
    SetEditTaxInvoiceModel(transaction, transactionDetail);
  },
  SetCreateReceiptFromBillingNote(transaction, transactionDetail) {
    return SetCreateReceiptFromBillingNote(transaction, transactionDetail);
  },
  SetCreateReceiptFromInvoice(transaction, transactionDetail, allocationList) {
    return SetCreateReceiptFromInvoice(transaction, transactionDetail, allocationList);
  },
  SetCreateCreditNoteModel(transaction, transactionDetail, allocationList) {
    return SetCreateCreditNoteModel(transaction, transactionDetail, allocationList);
  },
  SetCreateDebitNoteModel(transaction, transactionDetail, allocationList) {
    return SetCreateDebitNoteModel(transaction, transactionDetail, allocationList);
  },
  SetTransactionForDoPaidPayment(transaction, transactionDetail, transactionType, accountListForMap) {
    return SetTransactionForDoPaidPayment(transaction, transactionDetail, transactionType, accountListForMap);
  },
  SetBillingNoteForDoPaidPayment(transaction, transactionDetail) {
    return SetBillingNoteForDoPaidPayment(transaction, transactionDetail);
  },
  SetTransactionCurrencyForCreateTransactionByQuotation(transactionDetail, currencyExchangeRates) {
    return SetTransactionCurrencyForCreateTransactionByQuotation(transactionDetail, currencyExchangeRates);
  },
  SetInvoiceForCreateCreditNote(transaction, transactionDetail, allocationList) {
    return SetInvoiceForCreateCreditNote(transaction, transactionDetail, allocationList);
  },
  SetReceiptForCreateCreditNote(transaction, transactionDetail, allocationList) {
    return SetReceiptForCreateCreditNote(transaction, transactionDetail, allocationList);
  },
  SetBookmarkForTransaction(transaction, bookmarkDetailModel) {
    return SetBookmarkForTransaction(transaction, bookmarkDetailModel);
  },
  SetAITransactionModel(transaction, transactionDetail, allocationList) {
    return SetAITransactionModel(transaction, transactionDetail, allocationList);
  },
  SetAIChartOfAccount(transaction, contactId, aiSuggestionTransaction, transactionType, financeType, expenseType) {
    return SetAIChartOfAccount(
      transaction,
      contactId,
      aiSuggestionTransaction,
      transactionType,
      financeType,
      expenseType
    );
  },
  GetTransactionForEasyEditAllocation(transactionDetail, allocationList) {
    return GetTransactionForEasyEditAllocation(transactionDetail, allocationList);
  },
  GetContactCodeForCreateOrEdit(contactId, isShowAlert = false) {
    return new Promise(async (resolve) => {
      await store.dispatch("DoGetContactByContactIdList", [contactId]);
      let contactList = store.getters.GetContactModelList;
      let contact = contactList.find((x) => x.id === contactId);
      if (contact) {
        if (contact.isArchived && isShowAlert)
          store.dispatch("SetAlertMessage", {
            alertMessage: i18n.t("Select_Contact_Failed_Because_Contact_Was_Archived"),
            typeMessage: Enums.TypeComponentNoti.error,
          });
        resolve(contact.contactCode);
      }
      resolve("");
    });
  },
  GetContactForTransaction(transaction, checkIsArchived) {
    return new Promise(async (resolve, reject) => {
      try {
        await store.dispatch("DoGetContactByContactIdList", [transaction.contact.id]);
        let contactList = store.getters.GetContactModelList;
        let contact = contactList.find((x) => x.id === transaction.contact.id);

        if (contact) {
          if (checkIsArchived && (contact.isArchived || contact.isDeleted)) {
            transaction.contact = importHelper.SelectedContact(transaction.contact, null);
            store.dispatch("SetAlertMessage", {
              alertMessage: i18n.t("Select_Contact_Failed_Because_Contact_Was_Archived"),
              typeMessage: Enums.TypeComponentNoti.error,
            });
          } else {
            transaction.contact = importHelper.SelectedContact(transaction.contact, contact);
          }
        }
        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  GetProductForTransaction(transaction) {
    return new Promise(async (resolve) => {
      try {
        let productIdList = [];
        for (const transactionItem of transaction.transactionItemList) {
          if (transactionItem.productTemplate.id > 0) {
            productIdList.push(transactionItem.productTemplate.id);
          }
        }

        if (productIdList.length > 0) {
          await store.dispatch("DoGetProductTemplateByProductIdList", productIdList);
          let productList = store.getters.GetProductTemplateModelList;
          for (let transactionItem of transaction.transactionItemList) {
            if (transactionItem.productTemplate.id > 0) {
              let product = productList.find((x) => x.id === transactionItem.productTemplate.id);
              if (product) {
                transactionItem.productTemplate.id = 0;
                transactionItem = importHelper.SelectedProductTransaction(
                  transactionItem,
                  product,
                  transaction.transactionType,
                  transaction.financeType,
                  transaction.taxStatus.value
                );
              }
            }
          }
        }

        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  GetAssetTemplateForTransaction(transaction) {
    return new Promise(async (resolve) => {
      try {
        const assetTemplateIdList = [];
        for (const transactionItem of transaction.transactionItemList) {
          if (transactionItem.fixedAssetTemplate.id > 0) {
            assetTemplateIdList.push(transactionItem.fixedAssetTemplate.id);
          }
        }

        if (assetTemplateIdList.length > 0) {
          await store.dispatch("DoGetAssetTemplateListByAssetTemplateIdList", assetTemplateIdList);
          const fixedAssetTemplateList = store.getters.GetAssetTemplateModelList;

          for (let transactionItem of transaction.transactionItemList) {
            if (transactionItem.fixedAssetTemplate.id > 0) {
              const fixedAssetTemplate = fixedAssetTemplateList.find(
                (x) => x.id === transactionItem.fixedAssetTemplate.id
              );
              if (fixedAssetTemplate) {
                transactionItem.fixedAssetTemplate.id = 0;
                transactionItem = importHelper.SelectedAssetTemplateTransaction(transactionItem, fixedAssetTemplate);
              }
            }
          }
        }

        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  GetDepositNumberForTransaction(transaction) {
    return new Promise(async (resolve) => {
      try {
        const transactionIdList = [];
        for (const referenceDeposit of transaction.referenceDepositList) {
          if (referenceDeposit.depositId > 0) {
            transactionIdList.push(referenceDeposit.depositId);
          }
        }

        if (transactionIdList.length > 0) {
          const transactionTypeListForMap = await store.dispatch("DoGetTransactionViewDetailForDisplay", {
            transactionIdList: transactionIdList,
            transactionType: Enums.TransactionType.Deposit,
          });

          if (transactionTypeListForMap.has(Enums.TransactionType.Deposit)) {
            const transactionMap = transactionTypeListForMap.get(Enums.TransactionType.Deposit);

            for (const referenceDeposit of transaction.referenceDepositList) {
              const transaction = transactionMap.get(referenceDeposit.depositId);
              if (transaction) {
                referenceDeposit.depositNumber = transaction.number;
              }
            }
          }
        }

        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  GetDepositRemainingListForTransactionEdit(transaction) {
    return new Promise(async (resolve) => {
      try {
        const transactionIdList = [];
        for (const referenceDeposit of transaction.referenceDepositList) {
          if (referenceDeposit.depositId > 0) {
            transactionIdList.push(referenceDeposit.depositId);
          }
        }

        if (transactionIdList.length > 0) {
          const actionName =
            transaction.financeType === Enums.FinanceType.InFlow
              ? "DoGetDepositRemainingListForEdit"
              : "DoGetReceivedDepositRemainingListForEdit";
          const transactionRemainingList = await store.dispatch(actionName, {
            depositIdList: transactionIdList,
            transactionId: transaction.id,
            transactionType: transaction.transactionType,
          });

          if (transactionRemainingList && transactionRemainingList.length > 0) {
            const transactionRemainingListForMap = new Map();
            for (const transactionRemaining of transactionRemainingList) {
              transactionRemainingListForMap.set(transactionRemaining.id, transactionRemaining);
            }

            for (const referenceDeposit of transaction.referenceDepositList) {
              const transactionRemaining = transactionRemainingListForMap.get(referenceDeposit.depositId);
              if (transaction) {
                referenceDeposit.date = transactionRemaining.date;
              }
            }
          }
        }

        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  GetReferenceTransactionNumberForTransactionDetail(transactionDetail) {
    return new Promise(async (resolve) => {
      try {
        if (transactionDetail.referenceId > 0 && transactionDetail.referenceType > 0) {
          const transactionIdList = [transactionDetail.referenceId];

          if (transactionIdList.length > 0) {
            const transactionTypeListForMap = await store.dispatch("DoGetTransactionViewDetailForDisplay", {
              transactionIdList: transactionIdList,
              transactionType: transactionDetail.referenceType,
            });

            if (transactionTypeListForMap.has(transactionDetail.referenceType)) {
              const transactionMap = transactionTypeListForMap.get(transactionDetail.referenceType);

              const transaction = transactionMap.get(transactionDetail.referenceId);
              if (transaction) {
                transactionDetail.referenceNumber = transaction.number;
                transactionDetail.referenceContactId = transaction.contactId;
              }
            }
          }
        }
        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  SetCreateAllocationTransaction(financeType, allocationList) {
    return transactionHelper.SetCreateAllocationTransaction(FilterAllocationByFinanceType(financeType, allocationList));
  },
  IsPurchaseRequisitionApproved(transaction) {
    return (
      transaction.status != Enums.PurchaseRequisitionStatus.Draft &&
      transaction.status != Enums.PurchaseRequisitionStatus.AwaitApproval
    );
  },
  IsQuotationApproved(transaction) {
    return (
      transaction.status != Enums.QuotationStatus.Draft && transaction.status != Enums.QuotationStatus.AwaitApproval
    );
  },
  IsDepositApproved(transaction) {
    return transaction.status != Enums.DepositStatus.Draft && transaction.status != Enums.DepositStatus.AwaitApproval;
  },
  IsGoodsReceiptApproved(transaction) {
    return (
      transaction.status != Enums.GoodsReceiptStatus.Draft &&
      transaction.status != Enums.GoodsReceiptStatus.AwaitApproval
    );
  },
  IsInvoiceReceiptApproved(transaction) {
    return (
      transaction.status != Enums.InvoiceReceiptStatus.Draft &&
      transaction.status != Enums.InvoiceReceiptStatus.AwaitApproval
    );
  },
  IsInvoiceApproved(transaction) {
    return transaction.status != Enums.InvoiceStatus.Draft && transaction.status != Enums.InvoiceStatus.AwaitApproval;
  },
  IsReceiptApproved(transaction) {
    return transaction.status != Enums.ReceiptStatus.Draft && transaction.status != Enums.ReceiptStatus.AwaitApproval;
  },
  IsTaxInvoiceApproved(transaction) {
    return (
      transaction.status != Enums.TaxInvoiceStatus.Draft && transaction.status != Enums.TaxInvoiceStatus.AwaitApproval
    );
  },
  IsCreditNoteApproved(transaction) {
    return (
      transaction.status != Enums.CreditNoteStatus.Draft && transaction.status != Enums.CreditNoteStatus.AwaitApproval
    );
  },
  IsBillingNoteApproved(transaction) {
    return (
      transaction.status != Enums.BillingNoteStatus.Draft && transaction.status != Enums.BillingNoteStatus.AwaitApproval
    );
  },
  IsDebitNoteApproved(transaction) {
    return (
      transaction.status != Enums.DebitNoteStatus.Draft && transaction.status != Enums.DebitNoteStatus.AwaitApproval
    );
  },
  CheckOnlySelfDocuments(transactionDetailUserId, userId, isOnlySelfDocuments) {
    if (transactionDetailUserId != userId && isOnlySelfDocuments) {
      return true;
    } else {
      return false;
    }
  },
  CheckIsShowAllocationTap(transaction) {
    switch (transaction.transactionType) {
      case Enums.TransactionType.Receipt:
        if (
          transaction.reference.referenceTypeId == Enums.ReceiptReferenceType.None ||
          transaction.reference.referenceTypeId == Enums.ReceiptReferenceType.Quotation ||
          transaction.reference.referenceTypeId == Enums.ReceiptReferenceType.Invoice
        ) {
          return true;
        }
        break;
      case Enums.TransactionType.Quotation:
      case Enums.TransactionType.Invoice:
      case Enums.TransactionType.PurchaseRequisition:
      case Enums.TransactionType.CreditNote:
      case Enums.TransactionType.DebitNote:
      case Enums.TransactionType.Deposit:
      case Enums.TransactionType.GoodsReceipt:
      case Enums.TransactionType.InvoiceReceipt:
        return true;
      default:
        break;
    }
    return false;
  },
};
